var _rect, _g, _path, _tspan, _tspan2, _tspan3, _tspan4, _tspan5, _tspan6, _path2, _tspan7, _tspan8, _tspan9, _tspan10, _tspan11, _tspan12, _tspan13, _tspan14, _tspan15, _tspan16, _g2, _tspan17, _tspan18, _tspan19, _tspan20, _tspan21, _tspan22, _tspan23, _tspan24, _tspan25, _tspan26, _tspan27, _tspan28, _tspan29, _tspan30, _tspan31, _tspan32, _tspan33, _tspan34, _tspan35, _tspan36, _tspan37, _tspan38, _tspan39, _tspan40, _tspan41, _tspan42, _tspan43, _tspan44, _tspan45, _tspan46, _tspan47, _tspan48, _tspan49, _tspan50, _tspan51, _tspan52, _tspan53, _tspan54, _tspan55, _tspan56, _tspan57, _tspan58, _tspan59, _tspan60, _tspan61, _tspan62, _tspan63, _tspan64, _tspan65, _tspan66, _tspan67, _tspan68, _tspan69, _tspan70, _tspan71, _tspan72, _tspan73, _tspan74, _tspan75, _tspan76, _tspan77, _tspan78, _tspan79, _tspan80, _tspan81, _tspan82, _tspan83, _tspan84, _tspan85, _tspan86, _tspan87, _tspan88, _tspan89, _tspan90, _tspan91, _tspan92, _tspan93, _tspan94, _tspan95, _tspan96, _tspan97, _tspan98, _tspan99, _tspan100, _tspan101, _tspan102, _tspan103, _tspan104, _tspan105, _tspan106, _tspan107, _tspan108, _tspan109, _tspan110, _tspan111, _tspan112, _tspan113, _tspan114, _tspan115, _tspan116, _tspan117, _tspan118, _tspan119, _tspan120, _tspan121, _tspan122, _tspan123, _tspan124, _tspan125, _tspan126, _tspan127, _tspan128, _tspan129, _tspan130, _tspan131, _tspan132, _tspan133, _tspan134, _tspan135, _tspan136, _tspan137, _tspan138, _tspan139, _tspan140, _tspan141, _tspan142, _tspan143, _tspan144, _tspan145, _tspan146, _tspan147, _tspan148, _tspan149, _tspan150, _tspan151, _tspan152, _tspan153, _tspan154, _tspan155, _tspan156, _tspan157, _tspan158, _tspan159, _tspan160, _tspan161, _tspan162, _tspan163, _tspan164, _tspan165, _tspan166, _tspan167, _tspan168, _tspan169, _tspan170, _tspan171, _tspan172, _tspan173, _tspan174, _tspan175, _tspan176, _tspan177, _tspan178, _tspan179, _tspan180, _tspan181, _tspan182, _tspan183, _tspan184, _tspan185, _tspan186, _tspan187, _tspan188, _tspan189, _tspan190, _tspan191, _tspan192, _tspan193, _tspan194, _tspan195, _tspan196, _tspan197, _tspan198, _tspan199, _tspan200, _tspan201, _tspan202, _tspan203, _tspan204, _tspan205, _tspan206, _tspan207, _tspan208, _tspan209, _tspan210, _tspan211, _tspan212, _tspan213, _tspan214, _tspan215, _tspan216, _tspan217, _tspan218, _tspan219, _tspan220, _tspan221, _tspan222, _tspan223, _tspan224, _tspan225, _tspan226, _tspan227, _tspan228, _tspan229, _tspan230, _tspan231, _tspan232, _tspan233, _tspan234, _tspan235, _tspan236, _tspan237, _tspan238, _tspan239, _tspan240, _tspan241, _tspan242, _tspan243, _tspan244, _tspan245, _tspan246, _tspan247, _tspan248, _tspan249, _tspan250, _tspan251, _tspan252, _tspan253, _tspan254, _tspan255, _tspan256, _tspan257, _tspan258, _tspan259, _tspan260, _tspan261, _tspan262, _tspan263, _tspan264, _tspan265, _tspan266, _tspan267, _tspan268, _tspan269, _tspan270, _tspan271, _tspan272, _tspan273, _tspan274, _tspan275, _tspan276, _tspan277, _tspan278, _tspan279, _tspan280, _tspan281, _tspan282, _tspan283, _tspan284, _tspan285, _tspan286, _tspan287, _tspan288, _tspan289, _tspan290, _tspan291, _tspan292, _tspan293, _tspan294, _tspan295, _tspan296, _tspan297, _tspan298, _tspan299, _tspan300, _tspan301, _tspan302, _tspan303, _tspan304, _tspan305, _tspan306, _tspan307, _tspan308, _tspan309, _tspan310, _tspan311, _tspan312, _tspan313, _tspan314, _tspan315, _tspan316, _tspan317, _tspan318, _tspan319, _tspan320, _tspan321, _tspan322, _tspan323, _tspan324, _tspan325, _tspan326, _tspan327, _tspan328, _tspan329, _tspan330, _tspan331, _tspan332, _tspan333, _tspan334, _tspan335, _tspan336, _tspan337, _tspan338, _tspan339, _tspan340, _tspan341, _tspan342, _tspan343, _tspan344, _tspan345, _tspan346, _tspan347, _tspan348, _tspan349, _tspan350, _tspan351, _tspan352, _tspan353, _tspan354, _tspan355, _tspan356, _tspan357, _tspan358, _tspan359, _tspan360, _tspan361, _tspan362, _tspan363, _tspan364, _tspan365, _tspan366, _tspan367, _tspan368, _tspan369, _tspan370, _tspan371, _tspan372, _tspan373, _tspan374, _tspan375, _tspan376, _tspan377, _tspan378, _tspan379, _tspan380, _tspan381, _tspan382, _g3, _tspan383, _tspan384, _tspan385, _tspan386, _tspan387, _tspan388, _tspan389, _tspan390, _tspan391, _rect2, _rect3, _rect4, _tspan392, _rect5, _rect6, _tspan393, _g4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2048,
    height: 814,
    viewBox: "0 0 2048 814",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2048,
    height: 814,
    fill: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g_svg"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g_bkg"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 7",
    width: 2048,
    height: 814,
    fill: "#EAEAEA"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g_main"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g_description"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M947.161 31H424.191L304.881 40.9332H827.851L947.161 31Z",
    fill: "#EAEAEA"
  })), /*#__PURE__*/React.createElement("text", {
    id: "The period from 2020 to 2022 was marked by significant currency fluctuations in major nations, largely driven by a series of global shocks. These included the COVID-19 pandemic and geopolitical events, which led to substantial adjustments in exchange rates. The US dollar, in particular, strengthened against most currencies. This was a reflection of the differences in shock exposure across countries and the pace of monetary tightening. The broad US dollar index appreciated by around 10% since the beginning of 2022, reaching its highest level in almost four decades. This appreciation of the US dollar had significant macro-financial consequences. It led to a rise in foreign import prices and, coupled with a surge in commodity prices, compounded the impact on inflation. The dollar appreciation also resulted in a tightening of global financial conditions.",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 20,
    letterSpacing: "0em"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 88,
    y: 115.788
  }, "The period from 2020 to 2022 was marked by significant currency fluctuations in major nations, largely driven by a series of global shocks. These included the ")), _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 88,
    y: 139.788
  }, "COVID-19 pandemic and geopolitical events, which led to substantial adjustments in exchange rates.&#10;")), _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 88,
    y: 163.788
  }, "The US dollar, in particular, strengthened against most currencies. This was a reflection of the differences in shock exposure across countries and the pace of ")), _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    x: 88,
    y: 187.788
  }, "monetary tightening. The broad US dollar index appreciated by around 10% since the beginning of 2022, reaching its highest level in almost four decades.&#10;")), _tspan5 || (_tspan5 = /*#__PURE__*/React.createElement("tspan", {
    x: 88,
    y: 211.788
  }, "This appreciation of the US dollar had significant macro-financial consequences. It led to a rise in foreign import prices and, coupled with a surge in commodity prices, ")), _tspan6 || (_tspan6 = /*#__PURE__*/React.createElement("tspan", {
    x: 88,
    y: 235.788
  }, "compounded the impact on inflation. The dollar appreciation also resulted in a tightening of global financial conditions.")))), /*#__PURE__*/React.createElement("g", {
    id: "g_header"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2048 0H0V91.98H2048V0Z",
    fill: "#EAEAEA"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Currency Fluctuations in Major Nations: 2020-2022",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 48,
    letterSpacing: "0em"
  }, _tspan7 || (_tspan7 = /*#__PURE__*/React.createElement("tspan", {
    x: 412,
    y: 109.455
  }, "Currency Fluctuations in Major Nations: 2020-2022")))), /*#__PURE__*/React.createElement("g", {
    id: "g_info"
  }, /*#__PURE__*/React.createElement("g", {
    id: "currencyTexts",
    opacity: 0.98
  }, /*#__PURE__*/React.createElement("text", {
    id: "AUD",
    fill: "#262626",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan8 || (_tspan8 = /*#__PURE__*/React.createElement("tspan", {
    x: 223,
    y: 270.455
  }, "AUD"))), /*#__PURE__*/React.createElement("text", {
    id: "CAD",
    fill: "#262626",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan9 || (_tspan9 = /*#__PURE__*/React.createElement("tspan", {
    x: 223,
    y: 314.734
  }, "CAD"))), /*#__PURE__*/React.createElement("text", {
    id: "EURO",
    fill: "#262626",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan10 || (_tspan10 = /*#__PURE__*/React.createElement("tspan", {
    x: 223,
    y: 357.484
  }, "EURO"))), /*#__PURE__*/React.createElement("text", {
    id: "INR",
    fill: "#262626",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan11 || (_tspan11 = /*#__PURE__*/React.createElement("tspan", {
    x: 223,
    y: 403.274
  }, "INR"))), /*#__PURE__*/React.createElement("text", {
    id: "JPY",
    fill: "#262626",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan12 || (_tspan12 = /*#__PURE__*/React.createElement("tspan", {
    x: 223.34,
    y: 443.945
  }, "JPY"))), /*#__PURE__*/React.createElement("text", {
    id: "MXN",
    fill: "#262626",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan13 || (_tspan13 = /*#__PURE__*/React.createElement("tspan", {
    x: 223,
    y: 491.825
  }, "MXN"))), /*#__PURE__*/React.createElement("text", {
    id: "POUND",
    fill: "#262626",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan14 || (_tspan14 = /*#__PURE__*/React.createElement("tspan", {
    x: 223,
    y: 536.095
  }, "POUND"))), /*#__PURE__*/React.createElement("text", {
    id: "RMB",
    fill: "#262626",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan15 || (_tspan15 = /*#__PURE__*/React.createElement("tspan", {
    x: 223,
    y: 580.365
  }, "RMB"))), /*#__PURE__*/React.createElement("text", {
    id: "RUB",
    fill: "#262626",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan16 || (_tspan16 = /*#__PURE__*/React.createElement("tspan", {
    x: 223,
    y: 624.644
  }, "RUB")))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "g_percentageGroup"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect-324",
    d: "M1885.7 593.34V636.56H1841.4V593.34H1885.7Z",
    fill: "#BABFC9",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-323",
    d: "M1885.7 550.12H1841.4V593.34H1885.7V550.12Z",
    fill: "#E5A8A8",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-322",
    d: "M1885.7 506.9H1841.4V550.12H1885.7V506.9Z",
    fill: "#D87D7D",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-321",
    d: "M1885.7 463.68H1841.4V506.9H1885.7V463.68Z",
    fill: "#7D8698",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-320",
    d: "M1885.7 420.46H1841.4V463.68H1885.7V420.46Z",
    fill: "#D87D7D",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-319",
    d: "M1885.7 377.24H1841.4V420.46H1885.7V377.24Z",
    fill: "#C94949",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-318",
    d: "M1885.7 334.02H1841.4V377.24H1885.7V334.02Z",
    fill: "#DE8E8E",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-317",
    d: "M1885.7 290.8H1841.4V334.02H1885.7V290.8Z",
    fill: "#D67474",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-316",
    d: "M1885.7 247.58H1841.4V290.8H1885.7V247.58Z",
    fill: "#DB8686",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-315",
    d: "M1841.4 593.34H1797.1V636.56H1841.4V593.34Z",
    fill: "#949BAA",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-314",
    d: "M1841.4 550.12H1797.1V593.34H1841.4V550.12Z",
    fill: "#CE5A5A",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-313",
    d: "M1841.4 506.9H1797.1V550.12H1841.4V506.9Z",
    fill: "#CE5A5A",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-312",
    d: "M1841.4 463.68H1797.1V506.9H1841.4V463.68Z",
    fill: "#6D778C",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-311",
    d: "M1841.4 420.46H1797.1V463.68H1841.4V420.46Z",
    fill: "#D16363",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-310",
    d: "M1841.4 377.24H1797.1V420.46H1841.4V377.24Z",
    fill: "#D36C6C",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-309",
    d: "M1841.4 334.02H1797.1V377.24H1841.4V334.02Z",
    fill: "#D36C6C",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-308",
    d: "M1841.4 290.8H1797.1V334.02H1841.4V290.8Z",
    fill: "#DE8E8E",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-307",
    d: "M1841.4 247.58H1797.1V290.8H1841.4V247.58Z",
    fill: "#D36C6C",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-306",
    d: "M1797.1 593.34H1752.8V636.56H1797.1V593.34Z",
    fill: "#949BAA",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-305",
    d: "M1797.1 550.12H1752.8V593.34H1797.1V550.12Z",
    fill: "#C94949",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-304",
    d: "M1797.1 506.9H1752.8V550.12H1797.1V506.9Z",
    fill: "#C94949",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-303",
    d: "M1797.1 463.68H1752.8V506.9H1797.1V463.68Z",
    fill: "#ABB0BC",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-302",
    d: "M1797.1 420.46H1752.8V463.68H1797.1V420.46Z",
    fill: "#C94949",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-301",
    d: "M1797.1 377.24H1752.8V420.46H1797.1V377.24Z",
    fill: "#CE5A5A",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-300",
    d: "M1797.1 334.02H1752.8V377.24H1797.1V334.02Z",
    fill: "#C94949",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-299",
    d: "M1797.1 290.8H1752.8V334.02H1797.1V290.8Z",
    fill: "#D36C6C",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-298",
    d: "M1797.1 247.58H1752.8V290.8H1797.1V247.58Z",
    fill: "#CE5A5A",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-297",
    d: "M1752.8 593.34H1708.5V636.56H1752.8V593.34Z",
    fill: "#7D8698",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-296",
    d: "M1752.8 550.12H1708.5V593.34H1752.8V550.12Z",
    fill: "#DB8686",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-295",
    d: "M1752.8 506.9H1708.5V550.12H1752.8V506.9Z",
    fill: "#C94949",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-294",
    d: "M1752.8 463.68H1708.5V506.9H1752.8V463.68Z",
    fill: "#ABB0BC",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-293",
    d: "M1752.8 420.46H1708.5V463.68H1752.8V420.46Z",
    fill: "#CE5A5A",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-292",
    d: "M1752.8 377.24H1708.5V420.46H1752.8V377.24Z",
    fill: "#D87D7D",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-291",
    d: "M1752.8 334.02H1708.5V377.24H1752.8V334.02Z",
    fill: "#CE5A5A",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-290",
    d: "M1752.8 290.8H1708.5V334.02H1752.8V290.8Z",
    fill: "#E09797",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-289",
    d: "M1752.8 247.58H1708.5V290.8H1752.8V247.58Z",
    fill: "#D87D7D",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-288",
    d: "M1708.5 593.34H1664.2V636.56H1708.5V593.34Z",
    fill: "#848D9E",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-287",
    d: "M1708.5 550.12H1664.2V593.34H1708.5V550.12Z",
    fill: "#F2D4D4",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-286",
    d: "M1708.5 506.9H1664.2V550.12H1708.5V506.9Z",
    fill: "#D36C6C",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-285",
    d: "M1708.5 463.68H1664.2V506.9H1708.5V463.68Z",
    fill: "#BABFC9",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-284",
    d: "M1708.5 420.46H1664.2V463.68H1708.5V420.46Z",
    fill: "#D87D7D",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-283",
    d: "M1708.5 377.24H1664.2V420.46H1708.5V377.24Z",
    fill: "#DB8686",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-282",
    d: "M1708.5 334.02H1664.2V377.24H1708.5V334.02Z",
    fill: "#D16363",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-281",
    d: "M1708.5 290.8H1664.2V334.02H1708.5V290.8Z",
    fill: "#EDC2C2",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-280",
    d: "M1708.5 247.58H1664.2V290.8H1708.5V247.58Z",
    fill: "#E5A8A8",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-279",
    d: "M1664.2 593.34H1619.9V636.56H1664.2V593.34Z",
    fill: "#667086",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-278",
    d: "M1664.2 550.12H1619.9V593.34H1664.2V550.12Z",
    fill: "#F7E5E5",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-277",
    d: "M1664.2 506.9H1619.9V550.12H1664.2V506.9Z",
    fill: "#D36C6C",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-276",
    d: "M1664.2 463.68H1619.9V506.9H1664.2V463.68Z",
    fill: "#F0CBCB",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-275",
    d: "M1664.2 420.46H1619.9V463.68H1664.2V420.46Z",
    fill: "#D36C6C",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-274",
    d: "M1664.2 377.24H1619.9V420.46H1664.2V377.24Z",
    fill: "#DB8686",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-273",
    d: "M1664.2 334.02H1619.9V377.24H1664.2V334.02Z",
    fill: "#D36C6C",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-272",
    d: "M1664.2 290.8H1619.9V334.02H1664.2V290.8Z",
    fill: "#EDC2C2",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-271",
    d: "M1664.2 247.58H1619.9V290.8H1664.2V247.58Z",
    fill: "#DE8E8E",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-270",
    d: "M1619.9 593.34H1575.6V636.56H1619.9V593.34Z",
    fill: "#5E6980",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-269",
    d: "M1619.9 550.12H1575.6V593.34H1619.9V550.12Z",
    fill: "#FCF6F6",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-268",
    d: "M1619.9 506.9H1575.6V550.12H1619.9V506.9Z",
    fill: "#DE8E8E",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-267",
    d: "M1619.9 463.68H1575.6V506.9H1619.9V463.68Z",
    fill: "#ABB0BC",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-266",
    d: "M1619.9 420.46H1575.6V463.68H1619.9V420.46Z",
    fill: "#DB8686",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-265",
    d: "M1619.9 377.24H1575.6V420.46H1619.9V377.24Z",
    fill: "#DE8E8E",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-264",
    d: "M1619.9 334.02H1575.6V377.24H1619.9V334.02Z",
    fill: "#DB8686",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-263",
    d: "M1619.9 290.8H1575.6V334.02H1619.9V290.8Z",
    fill: "#BABFC9",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-262",
    d: "M1619.9 247.58H1575.6V290.8H1619.9V247.58Z",
    fill: "#E8B1B1",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-261",
    d: "M1575.6 593.34H1531.3V636.56H1575.6V593.34Z",
    fill: "#BABFC9",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-260",
    d: "M1575.6 550.12H1531.3V593.34H1575.6V550.12Z",
    fill: "#FAEEEE",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-259",
    d: "M1575.6 506.9H1531.3V550.12H1575.6V506.9Z",
    fill: "#E09797",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-258",
    d: "M1575.6 463.68H1531.3V506.9H1575.6V463.68Z",
    fill: "#ABB0BC",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-257",
    d: "M1575.6 420.46H1531.3V463.68H1575.6V420.46Z",
    fill: "#DE8E8E",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-256",
    d: "M1575.6 377.24H1531.3V420.46H1575.6V377.24Z",
    fill: "#E3A0A0",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-255",
    d: "M1575.6 334.02H1531.3V377.24H1575.6V334.02Z",
    fill: "#DB8686",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-254",
    d: "M1575.6 290.8H1531.3V334.02H1575.6V290.8Z",
    fill: "#EDC2C2",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-253",
    d: "M1575.6 247.58H1531.3V290.8H1575.6V247.58Z",
    fill: "#E8B1B1",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-252",
    d: "M1531.3 593.34H1487V636.56H1531.3V593.34Z",
    fill: "#D87D7D",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-251",
    d: "M1531.3 550.12H1487V593.34H1531.3V550.12Z",
    fill: "#9BA2B0",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-250",
    d: "M1531.3 506.9H1487V550.12H1531.3V506.9Z",
    fill: "#E5A8A8",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-249",
    d: "M1531.3 463.68H1487V506.9H1531.3V463.68Z",
    fill: "#ABB0BC",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-248",
    d: "M1531.3 420.46H1487V463.68H1531.3V420.46Z",
    fill: "#E3A0A0",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-247",
    d: "M1531.3 377.24H1487V420.46H1531.3V377.24Z",
    fill: "#E8B1B1",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-246",
    d: "M1531.3 334.02H1487V377.24H1531.3V334.02Z",
    fill: "#E09797",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-245",
    d: "M1531.3 290.8H1487V334.02H1531.3V290.8Z",
    fill: "#868FA0",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-244",
    d: "M1531.3 247.58H1487V290.8H1531.3V247.58Z",
    fill: "#838EA4",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-243",
    d: "M1487 593.34H1442.7V636.56H1487V593.34Z",
    fill: "#C94949",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-242",
    d: "M1487 550.12H1442.7V593.34H1487V550.12Z",
    fill: "#5E6980",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-241",
    d: "M1487 506.9H1442.7V550.12H1487V506.9Z",
    fill: "#EABABA",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-240",
    d: "M1487 463.68H1442.7V506.9H1487V463.68Z",
    fill: "#F0CBCB",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-239",
    d: "M1487 420.46H1442.7V463.68H1487V420.46Z",
    fill: "#E5A8A8",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-238",
    d: "M1487 377.24H1442.7V420.46H1487V377.24Z",
    fill: "#E8B1B1",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-237",
    d: "M1487 334.02H1442.7V377.24H1487V334.02Z",
    fill: "#EABABA",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-236",
    d: "M1487 290.8H1442.7V334.02H1487V290.8Z",
    fill: "#A3A9B6",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-235",
    d: "M1487 247.58H1442.7V290.8H1487V247.58Z",
    fill: "#8A95A9",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-234",
    d: "M1442.7 593.34H1398.4V636.56H1442.7V593.34Z",
    fill: "#E09797",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-233",
    d: "M1442.7 550.12H1398.4V593.34H1442.7V550.12Z",
    fill: "#5E6980",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-232",
    d: "M1442.7 506.9H1398.4V550.12H1442.7V506.9Z",
    fill: "#9BA2B0",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-231",
    d: "M1442.7 463.68H1398.4V506.9H1442.7V463.68Z",
    fill: "#F5DCDC",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-230",
    d: "M1442.7 420.46H1398.4V463.68H1442.7V420.46Z",
    fill: "#E8B1B1",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-229",
    d: "M1442.7 377.24H1398.4V420.46H1442.7V377.24Z",
    fill: "#F2D4D4",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-228",
    d: "M1442.7 334.02H1398.4V377.24H1442.7V334.02Z",
    fill: "#B2B8C3",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-227",
    d: "M1442.7 290.8H1398.4V334.02H1442.7V290.8Z",
    fill: "#A3A9B6",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-226",
    d: "M1442.7 247.58H1398.4V290.8H1442.7V247.58Z",
    fill: "#EDC2C2",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-225",
    d: "M1398.4 593.34H1354.1V636.56H1398.4V593.34Z",
    fill: "#E8B1B1",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-224",
    d: "M1398.4 550.12H1354.1V593.34H1398.4V550.12Z",
    fill: "#667086",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-223",
    d: "M1398.4 506.9H1354.1V550.12H1398.4V506.9Z",
    fill: "#9BA2B0",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-222",
    d: "M1398.4 463.68H1354.1V506.9H1398.4V463.68Z",
    fill: "#F0CBCB",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-221",
    d: "M1398.4 420.46H1354.1V463.68H1398.4V420.46Z",
    fill: "#E8B1B1",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-220",
    d: "M1398.4 377.24H1354.1V420.46H1398.4V377.24Z",
    fill: "#BABFC9",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-219",
    d: "M1398.4 334.02H1354.1V377.24H1398.4V334.02Z",
    fill: "#B2B8C3",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-218",
    d: "M1398.4 290.8H1354.1V334.02H1398.4V290.8Z",
    fill: "#868FA0",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-217",
    d: "M1398.4 247.58H1354.1V290.8H1398.4V247.58Z",
    fill: "#B6BDC9",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-216",
    d: "M1354.1 593.34H1309.8V636.56H1354.1V593.34Z",
    fill: "#E8EAED",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-215",
    d: "M1354.1 550.12H1309.8V593.34H1354.1V550.12Z",
    fill: "#757E92",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-214",
    d: "M1354.1 506.9H1309.8V550.12H1354.1V506.9Z",
    fill: "#D1D4DB",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-213",
    d: "M1354.1 463.68H1309.8V506.9H1354.1V463.68Z",
    fill: "#E8B1B1",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-212",
    d: "M1354.1 420.46H1309.8V463.68H1354.1V420.46Z",
    fill: "#EDC2C2",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-211",
    d: "M1354.1 377.24H1309.8V420.46H1354.1V377.24Z",
    fill: "#F0CBCB",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-210",
    d: "M1354.1 334.02H1309.8V377.24H1354.1V334.02Z",
    fill: "#B2B8C3",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-209",
    d: "M1354.1 290.8H1309.8V334.02H1354.1V290.8Z",
    fill: "#BABFC9",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-208",
    d: "M1354.1 247.58H1309.8V290.8H1354.1V247.58Z",
    fill: "#EDC2C2",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-207",
    d: "M1309.8 593.34H1265.5V636.56H1309.8V593.34Z",
    fill: "#D1D4DB",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-206",
    d: "M1309.8 550.12H1265.5V593.34H1309.8V550.12Z",
    fill: "#7D8698",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-205",
    d: "M1309.8 506.9H1265.5V550.12H1309.8V506.9Z",
    fill: "#9BA2B0",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-204",
    d: "M1309.8 463.68H1265.5V506.9H1309.8V463.68Z",
    fill: "#E8B1B1",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-203",
    d: "M1309.8 420.46H1265.5V463.68H1309.8V420.46Z",
    fill: "#EDC2C2",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-202",
    d: "M1309.8 377.24H1265.5V420.46H1309.8V377.24Z",
    fill: "#C2C6CF",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-201",
    d: "M1309.8 334.02H1265.5V377.24H1309.8V334.02Z",
    fill: "#B2B8C3",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-200",
    d: "M1309.8 290.8H1265.5V334.02H1309.8V290.8Z",
    fill: "#868FA0",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-199",
    d: "M1309.8 247.58H1265.5V290.8H1309.8V247.58Z",
    fill: "#99A2B4",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-198",
    d: "M1265.5 593.34H1221.2V636.56H1265.5V593.34Z",
    fill: "#C2C6CF",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-197",
    d: "M1265.5 550.12H1221.2V593.34H1265.5V550.12Z",
    fill: "#8C94A4",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-196",
    d: "M1265.5 506.9H1221.2V550.12H1265.5V506.9Z",
    fill: "#7D8698",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-195",
    d: "M1265.5 463.68H1221.2V506.9H1265.5V463.68Z",
    fill: "#F0CBCB",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-194",
    d: "M1265.5 420.46H1221.2V463.68H1265.5V420.46Z",
    fill: "#F5DCDC",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-193",
    d: "M1265.5 377.24H1221.2V420.46H1265.5V377.24Z",
    fill: "#F5DCDC",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-192",
    d: "M1265.5 334.02H1221.2V377.24H1265.5V334.02Z",
    fill: "#9BA2B0",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-191",
    d: "M1265.5 290.8H1221.2V334.02H1265.5V290.8Z",
    fill: "#6E788D",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-190",
    d: "M1265.5 247.58H1221.2V290.8H1265.5V247.58Z",
    fill: "#838EA4",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-189",
    d: "M1221.2 593.34H1176.9V636.56H1221.2V593.34Z",
    fill: "#D9DBE1",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-188",
    d: "M1221.2 550.12H1176.9V593.34H1221.2V550.12Z",
    fill: "#ABB0BC",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-187",
    d: "M1221.2 506.9H1176.9V550.12H1221.2V506.9Z",
    fill: "#7D8698",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-186",
    d: "M1221.2 463.68H1176.9V506.9H1221.2V463.68Z",
    fill: "#ABB0BC",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-185",
    d: "M1221.2 420.46H1176.9V463.68H1221.2V420.46Z",
    fill: "#D1D4DB",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-184",
    d: "M1221.2 377.24H1176.9V420.46H1221.2V377.24Z",
    fill: "#949BAA",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-183",
    d: "M1221.2 334.02H1176.9V377.24H1221.2V334.02Z",
    fill: "#8C94A4",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-182",
    d: "M1221.2 290.8H1176.9V334.02H1221.2V290.8Z",
    fill: "#A3A9B6",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-181",
    d: "M1221.2 247.58H1176.9V290.8H1221.2V247.58Z",
    fill: "#99A2B4",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-180",
    d: "M1176.9 593.34H1132.6V636.56H1176.9V593.34Z",
    fill: "#E0E2E7",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-179",
    d: "M1176.9 550.12H1132.6V593.34H1176.9V550.12Z",
    fill: "#ABB0BC",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-178",
    d: "M1176.9 506.9H1132.6V550.12H1176.9V506.9Z",
    fill: "#6D778C",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-177",
    d: "M1176.9 463.68H1132.6V506.9H1176.9V463.68Z",
    fill: "#ABB0BC",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-176",
    d: "M1176.9 420.46H1132.6V463.68H1176.9V420.46Z",
    fill: "#D1D4DB",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-175",
    d: "M1176.9 377.24H1132.6V420.46H1176.9V377.24Z",
    fill: "#A3A9B6",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-174",
    d: "M1176.9 334.02H1132.6V377.24H1176.9V334.02Z",
    fill: "#8C94A4",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-173",
    d: "M1176.9 290.8H1132.6V334.02H1176.9V290.8Z",
    fill: "#868FA0",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-172",
    d: "M1176.9 247.58H1132.6V290.8H1176.9V247.58Z",
    fill: "#99A2B4",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-171",
    d: "M1132.6 593.34H1088.3V636.56H1132.6V593.34Z",
    fill: "#F7F8F9",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-170",
    d: "M1132.6 550.12H1088.3V593.34H1132.6V550.12Z",
    fill: "#B2B8C3",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-169",
    d: "M1132.6 506.9H1088.3V550.12H1132.6V506.9Z",
    fill: "#6D778C",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-168",
    d: "M1132.6 463.68H1088.3V506.9H1132.6V463.68Z",
    fill: "#9BA2B0",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-167",
    d: "M1132.6 420.46H1088.3V463.68H1132.6V420.46Z",
    fill: "#D1D4DB",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-166",
    d: "M1132.6 377.24H1088.3V420.46H1132.6V377.24Z",
    fill: "#C2C6CF",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-165",
    d: "M1132.6 334.02H1088.3V377.24H1132.6V334.02Z",
    fill: "#8C94A4",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-164",
    d: "M1132.6 290.8H1088.3V334.02H1132.6V290.8Z",
    fill: "#868FA0",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-163",
    d: "M1132.6 247.58H1088.3V290.8H1132.6V247.58Z",
    fill: "#838EA4",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-162",
    d: "M1088.3 593.34H1044V636.56H1088.3V593.34Z",
    fill: "#C9CDD5",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-161",
    d: "M1088.3 550.12H1044V593.34H1088.3V550.12Z",
    fill: "#949BAA",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-160",
    d: "M1088.3 506.9H1044V550.12H1088.3V506.9Z",
    fill: "#5E6980",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-159",
    d: "M1088.3 463.68H1044V506.9H1088.3V463.68Z",
    fill: "#9BA2B0",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-158",
    d: "M1088.3 420.46H1044V463.68H1088.3V420.46Z",
    fill: "#D1D4DB",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-157",
    d: "M1088.3 377.24H1044V420.46H1088.3V377.24Z",
    fill: "#949BAA",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-156",
    d: "M1088.3 334.02H1044V377.24H1088.3V334.02Z",
    fill: "#6D778C",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-155",
    d: "M1088.3 290.8H1044V334.02H1088.3V290.8Z",
    fill: "#768093",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-154",
    d: "M1088.3 247.58H1044V290.8H1088.3V247.58Z",
    fill: "#758199",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-153",
    d: "M1044 593.34H999.701V636.56H1044V593.34Z",
    fill: "#F0F1F3",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-152",
    d: "M1044 550.12H999.701V593.34H1044V550.12Z",
    fill: "#9BA2B0",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-151",
    d: "M1044 506.9H999.701V550.12H1044V506.9Z",
    fill: "#6D778C",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-150",
    d: "M1044 463.68H999.701V506.9H1044V463.68Z",
    fill: "#9BA2B0",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-149",
    d: "M1044 420.46H999.701V463.68H1044V420.46Z",
    fill: "#ABB0BC",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-148",
    d: "M1044 377.24H999.701V420.46H1044V377.24Z",
    fill: "#848D9E",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-147",
    d: "M1044 334.02H999.701V377.24H1044V334.02Z",
    fill: "#5E6980",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-146",
    d: "M1044 290.8H999.701V334.02H1044V290.8Z",
    fill: "#5E6980",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-145",
    d: "M1044 247.58H999.701V290.8H1044V247.58Z",
    fill: "#5E6980",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-144",
    d: "M999.7 593.34H955.4V636.56H999.7V593.34Z",
    fill: "#E5A8A8",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-143",
    d: "M999.7 550.12H955.4V593.34H999.7V550.12Z",
    fill: "#C9CDD5",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-142",
    d: "M999.7 506.9H955.4V550.12H999.7V506.9Z",
    fill: "#6D778C",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-141",
    d: "M999.7 463.68H955.4V506.9H999.7V463.68Z",
    fill: "#ABB0BC",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-140",
    d: "M999.7 420.46H955.4V463.68H999.7V420.46Z",
    fill: "#ABB0BC",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-139",
    d: "M999.7 377.24H955.4V420.46H999.7V377.24Z",
    fill: "#C2C6CF",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-138",
    d: "M999.7 334.02H955.4V377.24H999.7V334.02Z",
    fill: "#7D8698",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-137",
    d: "M999.7 290.8H955.4V334.02H999.7V290.8Z",
    fill: "#768093",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-136",
    d: "M999.7 247.58H955.4V290.8H999.7V247.58Z",
    fill: "#6D7B93",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-135",
    d: "M955.4 593.34H911.1V636.56H955.4V593.34Z",
    fill: "#F2D4D4",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-134",
    d: "M955.4 550.12H911.1V593.34H955.4V550.12Z",
    fill: "#C9CDD5",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-133",
    d: "M955.4 506.9H911.1V550.12H955.4V506.9Z",
    fill: "#6D778C",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-132",
    d: "M955.4 463.68H911.1V506.9H955.4V463.68Z",
    fill: "#EABABA",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-131",
    d: "M955.4 420.46H911.1V463.68H955.4V420.46Z",
    fill: "#ABB0BC",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-130",
    d: "M955.4 377.24H911.1V420.46H955.4V377.24Z",
    fill: "#757E92",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-129",
    d: "M955.4 334.02H911.1V377.24H955.4V334.02Z",
    fill: "#7D8698",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-128",
    d: "M955.4 290.8H911.1V334.02H955.4V290.8Z",
    fill: "#868FA0",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-127",
    d: "M955.4 247.58H911.1V290.8H955.4V247.58Z",
    fill: "#6D7B93",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-126",
    d: "M911.101 593.34H866.801V636.56H911.101V593.34Z",
    fill: "#F2D4D4",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-125",
    d: "M911.101 550.12H866.801V593.34H911.101V550.12Z",
    fill: "#ABB0BC",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-124",
    d: "M911.101 506.9H866.801V550.12H911.101V506.9Z",
    fill: "#6D778C",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-123",
    d: "M911.101 463.68H866.801V506.9H911.101V463.68Z",
    fill: "#D1D4DB",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-122",
    d: "M911.101 420.46H866.801V463.68H911.101V420.46Z",
    fill: "#6D778C",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-121",
    d: "M911.101 377.24H866.801V420.46H911.101V377.24Z",
    fill: "#7D8698",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-120",
    d: "M911.101 334.02H866.801V377.24H911.101V334.02Z",
    fill: "#6D778C",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-119",
    d: "M911.101 290.8H866.801V334.02H911.101V290.8Z",
    fill: "#A3A9B6",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-118",
    d: "M911.101 247.58H866.801V290.8H911.101V247.58Z",
    fill: "#5E6980",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-117",
    d: "M866.8 593.34H822.5V636.56H866.8V593.34Z",
    fill: "#F5DCDC",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-116",
    d: "M866.8 550.12H822.5V593.34H866.8V550.12Z",
    fill: "#B2B8C3",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-115",
    d: "M866.8 506.9H822.5V550.12H866.8V506.9Z",
    fill: "#7D8698",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-114",
    d: "M866.8 463.68H822.5V506.9H866.8V463.68Z",
    fill: "#8C94A4",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-113",
    d: "M866.8 420.46H822.5V463.68H866.8V420.46Z",
    fill: "#5E6980",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-112",
    d: "M866.8 377.24H822.5V420.46H866.8V377.24Z",
    fill: "#7D8698",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-111",
    d: "M866.8 334.02H822.5V377.24H866.8V334.02Z",
    fill: "#5E6980",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-110",
    d: "M866.8 290.8H822.5V334.02H866.8V290.8Z",
    fill: "#A3A9B6",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-109",
    d: "M866.8 247.58H822.5V290.8H866.8V247.58Z",
    fill: "#5E6980",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-108",
    d: "M822.501 593.34H778.201V636.56H822.501V593.34Z",
    fill: "#F7E5E5",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-107",
    d: "M822.501 550.12H778.201V593.34H822.501V550.12Z",
    fill: "#D1D4DB",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-106",
    d: "M822.501 506.9H778.201V550.12H822.501V506.9Z",
    fill: "#9BA2B0",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-105",
    d: "M822.501 463.68H778.201V506.9H822.501V463.68Z",
    fill: "#9BA2B0",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-104",
    d: "M822.501 420.46H778.201V463.68H822.501V420.46Z",
    fill: "#5E6980",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-103",
    d: "M822.501 377.24H778.201V420.46H822.501V377.24Z",
    fill: "#949BAA",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-102",
    d: "M822.501 334.02H778.201V377.24H822.501V334.02Z",
    fill: "#5E6980",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-101",
    d: "M822.501 290.8H778.201V334.02H822.501V290.8Z",
    fill: "#BABFC9",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-100",
    d: "M822.501 247.58H778.201V290.8H822.501V247.58Z",
    fill: "#7C889E",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-99",
    d: "M778.2 593.34H733.9V636.56H778.2V593.34Z",
    fill: "#E3A0A0",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-98",
    d: "M778.2 550.12H733.9V593.34H778.2V550.12Z",
    fill: "#E6EDF6",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-97",
    d: "M778.2 506.9H733.9V550.12H778.2V506.9Z",
    fill: "#EABABA",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-96",
    d: "M778.2 463.68H733.9V506.9H778.2V463.68Z",
    fill: "#FFDEDE",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-95",
    d: "M778.2 420.46H733.9V463.68H778.2V420.46Z",
    fill: "#5E6980",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-94",
    d: "M778.2 377.24H733.9V420.46H778.2V377.24Z",
    fill: "#A3A9B6",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-93",
    d: "M778.2 334.02H733.9V377.24H778.2V334.02Z",
    fill: "#8C94A4",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-92",
    d: "M778.2 290.8H733.9V334.02H778.2V290.8Z",
    fill: "#E8B1B1",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-91",
    d: "M778.2 247.58H733.9V290.8H778.2V247.58Z",
    fill: "#A8B0BE",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-90",
    d: "M733.9 593.34H689.6V636.56H733.9V593.34Z",
    fill: "#DE8E8E",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-89",
    d: "M733.9 550.12H689.6V593.34H733.9V550.12Z",
    fill: "#FCF6F6",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-88",
    d: "M733.9 506.9H689.6V550.12H733.9V506.9Z",
    fill: "#E5A8A8",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-87",
    d: "M733.9 463.68H689.6V506.9H733.9V463.68Z",
    fill: "#E3A0A0",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-86",
    d: "M733.9 420.46H689.6V463.68H733.9V420.46Z",
    fill: "#6D778C",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-85",
    d: "M733.9 377.24H689.6V420.46H733.9V377.24Z",
    fill: "#848D9E",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-84",
    d: "M733.9 334.02H689.6V377.24H733.9V334.02Z",
    fill: "#8C94A4",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-83",
    d: "M733.9 290.8H689.6V334.02H733.9V290.8Z",
    fill: "#E3A0A0",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-82",
    d: "M733.9 247.58H689.6V290.8H733.9V247.58Z",
    fill: "#EDC2C2",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-81",
    d: "M689.601 593.34H645.301V636.56H689.601V593.34Z",
    fill: "#EABABA",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-80",
    d: "M689.601 550.12H645.301V593.34H689.601V550.12Z",
    fill: "#F2D4D4",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-79",
    d: "M689.601 506.9H645.301V550.12H689.601V506.9Z",
    fill: "#E5A8A8",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-78",
    d: "M689.601 463.68H645.301V506.9H689.601V463.68Z",
    fill: "#E09797",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-77",
    d: "M689.601 420.46H645.301V463.68H689.601V420.46Z",
    fill: "#7D8698",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-76",
    d: "M689.601 377.24H645.301V420.46H689.601V377.24Z",
    fill: "#848D9E",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-75",
    d: "M689.601 334.02H645.301V377.24H689.601V334.02Z",
    fill: "#8C94A4",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-74",
    d: "M689.601 290.8H645.301V334.02H689.601V290.8Z",
    fill: "#E3A0A0",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-73",
    d: "M689.601 247.58H645.301V290.8H689.601V247.58Z",
    fill: "#A8B0BE",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-72",
    d: "M645.3 593.34H601V636.56H645.3V593.34Z",
    fill: "#F0F1F3",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-71",
    d: "M645.3 550.12H601V593.34H645.3V550.12Z",
    fill: "#F0CBCB",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-70",
    d: "M645.3 506.9H601V550.12H645.3V506.9Z",
    fill: "#EABABA",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-69",
    d: "M645.3 463.68H601V506.9H645.3V463.68Z",
    fill: "#DE8E8E",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-68",
    d: "M645.3 420.46H601V463.68H645.3V420.46Z",
    fill: "#7D8698",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-67",
    d: "M645.3 377.24H601V420.46H645.3V377.24Z",
    fill: "#D1D4DB",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-66",
    d: "M645.3 334.02H601V377.24H645.3V334.02Z",
    fill: "#8C94A4",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-65",
    d: "M645.3 290.8H601V334.02H645.3V290.8Z",
    fill: "#E3A0A0",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-64",
    d: "M645.3 247.58H601V290.8H645.3V247.58Z",
    fill: "#B6BDC9",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-63",
    d: "M601.001 593.34H556.701V636.56H601.001V593.34Z",
    fill: "#C2C6CF",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-62",
    d: "M601.001 550.12H556.701V593.34H601.001V550.12Z",
    fill: "#E09797",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-61",
    d: "M601.001 506.9H556.701V550.12H601.001V506.9Z",
    fill: "#E3A0A0",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-60",
    d: "M601.001 463.68H556.701V506.9H601.001V463.68Z",
    fill: "#D67474",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-59",
    d: "M601.001 420.46H556.701V463.68H601.001V420.46Z",
    fill: "#8C94A4",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-58",
    d: "M601.001 377.24H556.701V420.46H601.001V377.24Z",
    fill: "#F2D4D4",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-57",
    d: "M601.001 334.02H556.701V377.24H601.001V334.02Z",
    fill: "#A3A9B6",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-56",
    d: "M601.001 290.8H556.701V334.02H601.001V290.8Z",
    fill: "#D87D7D",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-55",
    d: "M601.001 247.58H556.701V290.8H601.001V247.58Z",
    fill: "#E8B1B1",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-54",
    d: "M556.7 593.34H512.4V636.56H556.7V593.34Z",
    fill: "#9BA2B0",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-53",
    d: "M556.7 550.12H512.4V593.34H556.7V550.12Z",
    fill: "#D36C6C",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-52",
    d: "M556.7 506.9H512.4V550.12H556.7V506.9Z",
    fill: "#E09797",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-51",
    d: "M556.7 463.68H512.4V506.9H556.7V463.68Z",
    fill: "#D87D7D",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-50",
    d: "M556.7 420.46H512.4V463.68H556.7V420.46Z",
    fill: "#9BA2B0",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-49",
    d: "M556.7 377.24H512.4V420.46H556.7V377.24Z",
    fill: "#EDC2C2",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-48",
    d: "M556.7 334.02H512.4V377.24H556.7V334.02Z",
    fill: "#C2C6CF",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-47",
    d: "M556.7 290.8H512.4V334.02H556.7V290.8Z",
    fill: "#D67474",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-46",
    d: "M556.7 247.58H512.4V290.8H556.7V247.58Z",
    fill: "#E09797",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-45",
    d: "M512.4 593.34H468.1V636.56H512.4V593.34Z",
    fill: "#D1D4DB",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-44",
    d: "M512.4 550.12H468.1V593.34H512.4V550.12Z",
    fill: "#D16363",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-43",
    d: "M512.4 506.9H468.1V550.12H512.4V506.9Z",
    fill: "#DE8E8E",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-42",
    d: "M512.4 463.68H468.1V506.9H512.4V463.68Z",
    fill: "#D16363",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-41",
    d: "M512.4 420.46H468.1V463.68H512.4V420.46Z",
    fill: "#8C94A4",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-40",
    d: "M512.4 377.24H468.1V420.46H512.4V377.24Z",
    fill: "#EDC2C2",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-39",
    d: "M512.4 334.02H468.1V377.24H512.4V334.02Z",
    fill: "#E5A8A8",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-38",
    d: "M512.4 290.8H468.1V334.02H512.4V290.8Z",
    fill: "#CE5A5A",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-37",
    d: "M512.4 247.58H468.1V290.8H512.4V247.58Z",
    fill: "#D36C6C",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-36",
    d: "M468.101 593.34H423.801V636.56H468.101V593.34Z",
    fill: "#F0CBCB",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-35",
    d: "M468.101 550.12H423.801V593.34H468.101V550.12Z",
    fill: "#D67474",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-34",
    d: "M468.101 506.9H423.801V550.12H468.101V506.9Z",
    fill: "#DE8E8E",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-33",
    d: "M468.101 463.68H423.801V506.9H468.101V463.68Z",
    fill: "#C94949",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-32",
    d: "M468.101 420.46H423.801V463.68H468.101V420.46Z",
    fill: "#9BA2B0",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-31",
    d: "M468.101 377.24H423.801V420.46H468.101V377.24Z",
    fill: "#E8B1B1",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-30",
    d: "M468.101 334.02H423.801V377.24H468.101V334.02Z",
    fill: "#E5A8A8",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-29",
    d: "M468.101 290.8H423.801V334.02H468.101V290.8Z",
    fill: "#C94949",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-28",
    d: "M468.101 247.58H423.801V290.8H468.101V247.58Z",
    fill: "#C94949",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-27",
    d: "M423.8 593.34H379.5V636.56H423.8V593.34Z",
    fill: "#E0E2E7",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-26",
    d: "M423.8 550.12H379.5V593.34H423.8V550.12Z",
    fill: "#DE8E8E",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-25",
    d: "M423.8 506.9H379.5V550.12H423.8V506.9Z",
    fill: "#DE8E8E",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-24",
    d: "M423.8 463.68H379.5V506.9H423.8V463.68Z",
    fill: "#DE8E8E",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-23",
    d: "M423.8 420.46H379.5V463.68H423.8V420.46Z",
    fill: "#8C94A4",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-22",
    d: "M423.8 377.24H379.5V420.46H423.8V377.24Z",
    fill: "#BABFC9",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-21",
    d: "M423.8 334.02H379.5V377.24H423.8V334.02Z",
    fill: "#EABABA",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-20",
    d: "M423.8 290.8H379.5V334.02H423.8V290.8Z",
    fill: "#CE5A5A",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-19",
    d: "M423.8 247.58H379.5V290.8H423.8V247.58Z",
    fill: "#C94949",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-18",
    d: "M379.501 593.34H335.201V636.56H379.501V593.34Z",
    fill: "#B2B8C3",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-17",
    d: "M379.501 550.12H335.201V593.34H379.501V550.12Z",
    fill: "#E3A0A0",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-16",
    d: "M379.501 506.9H335.201V550.12H379.501V506.9Z",
    fill: "#E5A8A8",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-15",
    d: "M379.501 463.68H335.201V506.9H379.501V463.68Z",
    fill: "#5E6980",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-14",
    d: "M379.501 420.46H335.201V463.68H379.501V420.46Z",
    fill: "#D1D4DB",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-13",
    d: "M379.501 377.24H335.201V420.46H379.501V377.24Z",
    fill: "#667086",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-12",
    d: "M379.501 334.02H335.201V377.24H379.501V334.02Z",
    fill: "#E5A8A8",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-11",
    d: "M379.501 290.8H335.201V334.02H379.501V290.8Z",
    fill: "#E09797",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-10",
    d: "M379.501 247.58H335.201V290.8H379.501V247.58Z",
    fill: "#D87D7D",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-9",
    d: "M335.2 550.12H290.9V593.34H335.2V550.12Z",
    fill: "#F0CBCB",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-8",
    d: "M335.2 593.34H290.9V636.56H335.2V593.34Z",
    fill: "#ABB0BC",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-7",
    d: "M335.2 506.9H290.9V550.12H335.2V506.9Z",
    fill: "#EABABA",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-6",
    d: "M335.2 463.68H290.9V506.9H335.2V463.68Z",
    fill: "#5E6980",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-5",
    d: "M335.2 420.46H290.9V463.68H335.2V420.46Z",
    fill: "#ABB0BC",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-4",
    d: "M335.2 377.24H290.9V420.46H335.2V377.24Z",
    fill: "#5E6980",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-3",
    d: "M335.2 334.02H290.9V377.24H335.2V334.02Z",
    fill: "#F0CBCB",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-2",
    d: "M335.2 290.8H290.9V334.02H335.2V290.8Z",
    fill: "#E8B1B1",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect-1",
    d: "M335.2 247.58H290.9V290.8H335.2V247.58Z",
    fill: "#E09797",
    stroke: "white",
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Months and years"
  }, /*#__PURE__*/React.createElement("text", {
    id: 2020,
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 18,
    letterSpacing: "0em"
  }, _tspan17 || (_tspan17 = /*#__PURE__*/React.createElement("tspan", {
    x: 306.98,
    y: 195.396
  }, "2020"))), /*#__PURE__*/React.createElement("text", {
    id: 1,
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    letterSpacing: "0em"
  }, _tspan18 || (_tspan18 = /*#__PURE__*/React.createElement("tspan", {
    x: 306.98,
    y: 222.831
  }, "1"))), /*#__PURE__*/React.createElement("text", {
    id: 2,
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    letterSpacing: "0em"
  }, _tspan19 || (_tspan19 = /*#__PURE__*/React.createElement("tspan", {
    x: 351.32,
    y: 222.831
  }, "2"))), /*#__PURE__*/React.createElement("text", {
    id: 3,
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    letterSpacing: "0em"
  }, _tspan20 || (_tspan20 = /*#__PURE__*/React.createElement("tspan", {
    x: 395.66,
    y: 222.831
  }, "3"))), /*#__PURE__*/React.createElement("text", {
    id: 4,
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    letterSpacing: "0em"
  }, _tspan21 || (_tspan21 = /*#__PURE__*/React.createElement("tspan", {
    x: 439.99,
    y: 222.831
  }, "4"))), /*#__PURE__*/React.createElement("text", {
    id: 5,
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    letterSpacing: "0em"
  }, _tspan22 || (_tspan22 = /*#__PURE__*/React.createElement("tspan", {
    x: 484.33,
    y: 222.831
  }, "5"))), /*#__PURE__*/React.createElement("text", {
    id: 6,
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    letterSpacing: "0em"
  }, _tspan23 || (_tspan23 = /*#__PURE__*/React.createElement("tspan", {
    x: 528.67,
    y: 222.831
  }, "6"))), /*#__PURE__*/React.createElement("text", {
    id: 7,
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    letterSpacing: "0em"
  }, _tspan24 || (_tspan24 = /*#__PURE__*/React.createElement("tspan", {
    x: 573.01,
    y: 222.831
  }, "7"))), /*#__PURE__*/React.createElement("text", {
    id: 8,
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    letterSpacing: "0em"
  }, _tspan25 || (_tspan25 = /*#__PURE__*/React.createElement("tspan", {
    x: 617.35,
    y: 222.831
  }, "8"))), /*#__PURE__*/React.createElement("text", {
    id: 9,
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    letterSpacing: "0em"
  }, _tspan26 || (_tspan26 = /*#__PURE__*/React.createElement("tspan", {
    x: 661.68,
    y: 222.831
  }, "9"))), /*#__PURE__*/React.createElement("text", {
    id: 10,
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    letterSpacing: "0em"
  }, _tspan27 || (_tspan27 = /*#__PURE__*/React.createElement("tspan", {
    x: 706.02,
    y: 222.831
  }, "10"))), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("text", {
    id: "1_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    letterSpacing: "0em"
  }, _tspan28 || (_tspan28 = /*#__PURE__*/React.createElement("tspan", {
    x: 750.361,
    y: 222.831
  }, "1"))), /*#__PURE__*/React.createElement("text", {
    id: "1_3",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    letterSpacing: "0em"
  }, _tspan29 || (_tspan29 = /*#__PURE__*/React.createElement("tspan", {
    x: 757.371,
    y: 222.831
  }, "1")))), /*#__PURE__*/React.createElement("text", {
    id: 12,
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    letterSpacing: "0em"
  }, _tspan30 || (_tspan30 = /*#__PURE__*/React.createElement("tspan", {
    x: 794.701,
    y: 222.831
  }, "12"))), /*#__PURE__*/React.createElement("text", {
    id: "1_4",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    letterSpacing: "0em"
  }, _tspan31 || (_tspan31 = /*#__PURE__*/React.createElement("tspan", {
    x: 839.041,
    y: 222.831
  }, "1"))), /*#__PURE__*/React.createElement("text", {
    id: "2_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    letterSpacing: "0em"
  }, _tspan32 || (_tspan32 = /*#__PURE__*/React.createElement("tspan", {
    x: 883.371,
    y: 222.831
  }, "2"))), /*#__PURE__*/React.createElement("text", {
    id: "3_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    letterSpacing: "0em"
  }, _tspan33 || (_tspan33 = /*#__PURE__*/React.createElement("tspan", {
    x: 927.711,
    y: 222.831
  }, "3"))), /*#__PURE__*/React.createElement("text", {
    id: "4_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    letterSpacing: "0em"
  }, _tspan34 || (_tspan34 = /*#__PURE__*/React.createElement("tspan", {
    x: 972.051,
    y: 222.831
  }, "4"))), /*#__PURE__*/React.createElement("text", {
    id: 2021,
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 18,
    letterSpacing: "0em"
  }, _tspan35 || (_tspan35 = /*#__PURE__*/React.createElement("tspan", {
    x: 839.041,
    y: 195.396
  }, "2021"))), /*#__PURE__*/React.createElement("text", {
    id: 2022,
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 18,
    letterSpacing: "0em"
  }, _tspan36 || (_tspan36 = /*#__PURE__*/React.createElement("tspan", {
    x: 1371.09,
    y: 195.396
  }, "2022"))), /*#__PURE__*/React.createElement("text", {
    id: "5_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    letterSpacing: "0em"
  }, _tspan37 || (_tspan37 = /*#__PURE__*/React.createElement("tspan", {
    x: 1016.39,
    y: 222.831
  }, "5"))), /*#__PURE__*/React.createElement("text", {
    id: "6_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    letterSpacing: "0em"
  }, _tspan38 || (_tspan38 = /*#__PURE__*/React.createElement("tspan", {
    x: 1060.73,
    y: 222.831
  }, "6"))), /*#__PURE__*/React.createElement("text", {
    id: "7_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    letterSpacing: "0em"
  }, _tspan39 || (_tspan39 = /*#__PURE__*/React.createElement("tspan", {
    x: 1105.06,
    y: 222.831
  }, "7"))), /*#__PURE__*/React.createElement("text", {
    id: "8_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    letterSpacing: "0em"
  }, _tspan40 || (_tspan40 = /*#__PURE__*/React.createElement("tspan", {
    x: 1149.4,
    y: 222.831
  }, "8"))), /*#__PURE__*/React.createElement("text", {
    id: "9_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    letterSpacing: "0em"
  }, _tspan41 || (_tspan41 = /*#__PURE__*/React.createElement("tspan", {
    x: 1193.74,
    y: 222.831
  }, "9"))), /*#__PURE__*/React.createElement("text", {
    id: "10_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    letterSpacing: "0em"
  }, _tspan42 || (_tspan42 = /*#__PURE__*/React.createElement("tspan", {
    x: 1238.08,
    y: 222.831
  }, "10"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("text", {
    id: "1_5",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    letterSpacing: "0em"
  }, _tspan43 || (_tspan43 = /*#__PURE__*/React.createElement("tspan", {
    x: 1282.42,
    y: 222.831
  }, "1"))), /*#__PURE__*/React.createElement("text", {
    id: "1_6",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    letterSpacing: "0em"
  }, _tspan44 || (_tspan44 = /*#__PURE__*/React.createElement("tspan", {
    x: 1289.43,
    y: 222.831
  }, "1")))), /*#__PURE__*/React.createElement("text", {
    id: "12_2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    letterSpacing: "0em"
  }, _tspan45 || (_tspan45 = /*#__PURE__*/React.createElement("tspan", {
    x: 1326.76,
    y: 222.831
  }, "12"))), /*#__PURE__*/React.createElement("text", {
    id: "1_7",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    letterSpacing: "0em"
  }, _tspan46 || (_tspan46 = /*#__PURE__*/React.createElement("tspan", {
    x: 1371.09,
    y: 222.831
  }, "1"))), /*#__PURE__*/React.createElement("text", {
    id: "2_3",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    letterSpacing: "0em"
  }, _tspan47 || (_tspan47 = /*#__PURE__*/React.createElement("tspan", {
    x: 1415.43,
    y: 222.831
  }, "2"))), /*#__PURE__*/React.createElement("text", {
    id: "3_3",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    letterSpacing: "0em"
  }, _tspan48 || (_tspan48 = /*#__PURE__*/React.createElement("tspan", {
    x: 1459.77,
    y: 222.831
  }, "3"))), /*#__PURE__*/React.createElement("text", {
    id: "4_3",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    letterSpacing: "0em"
  }, _tspan49 || (_tspan49 = /*#__PURE__*/React.createElement("tspan", {
    x: 1504.11,
    y: 222.831
  }, "4"))), /*#__PURE__*/React.createElement("text", {
    id: "5_3",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    letterSpacing: "0em"
  }, _tspan50 || (_tspan50 = /*#__PURE__*/React.createElement("tspan", {
    x: 1548.45,
    y: 222.831
  }, "5"))), /*#__PURE__*/React.createElement("text", {
    id: "6_3",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    letterSpacing: "0em"
  }, _tspan51 || (_tspan51 = /*#__PURE__*/React.createElement("tspan", {
    x: 1592.78,
    y: 222.831
  }, "6"))), /*#__PURE__*/React.createElement("text", {
    id: "7_3",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    letterSpacing: "0em"
  }, _tspan52 || (_tspan52 = /*#__PURE__*/React.createElement("tspan", {
    x: 1637.12,
    y: 222.831
  }, "7"))), /*#__PURE__*/React.createElement("text", {
    id: "8_3",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    letterSpacing: "0em"
  }, _tspan53 || (_tspan53 = /*#__PURE__*/React.createElement("tspan", {
    x: 1681.46,
    y: 222.831
  }, "8"))), /*#__PURE__*/React.createElement("text", {
    id: "9_3",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    letterSpacing: "0em"
  }, _tspan54 || (_tspan54 = /*#__PURE__*/React.createElement("tspan", {
    x: 1725.8,
    y: 222.831
  }, "9"))), /*#__PURE__*/React.createElement("text", {
    id: "10_3",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    letterSpacing: "0em"
  }, _tspan55 || (_tspan55 = /*#__PURE__*/React.createElement("tspan", {
    x: 1770.14,
    y: 222.831
  }, "10"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("text", {
    id: "1_8",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    letterSpacing: "0em"
  }, _tspan56 || (_tspan56 = /*#__PURE__*/React.createElement("tspan", {
    x: 1814.47,
    y: 222.831
  }, "1"))), /*#__PURE__*/React.createElement("text", {
    id: "1_9",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    letterSpacing: "0em"
  }, _tspan57 || (_tspan57 = /*#__PURE__*/React.createElement("tspan", {
    x: 1821.48,
    y: 222.831
  }, "1")))), /*#__PURE__*/React.createElement("text", {
    id: "12_3",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 14,
    letterSpacing: "0em"
  }, _tspan58 || (_tspan58 = /*#__PURE__*/React.createElement("tspan", {
    x: 1858.81,
    y: 222.831
  }, "12")))), /*#__PURE__*/React.createElement("g", {
    id: "g_precentageTexts"
  }, /*#__PURE__*/React.createElement("text", {
    id: "text1",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan59 || (_tspan59 = /*#__PURE__*/React.createElement("tspan", {
    x: 299.76,
    y: 273.965
  }, "1.45"))), /*#__PURE__*/React.createElement("text", {
    id: "text2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan60 || (_tspan60 = /*#__PURE__*/React.createElement("tspan", {
    x: 299.76,
    y: 318.245
  }, "1.31"))), /*#__PURE__*/React.createElement("text", {
    id: "text3",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan61 || (_tspan61 = /*#__PURE__*/React.createElement("tspan", {
    x: 299.539,
    y: 362.515
  }, "0.9"))), /*#__PURE__*/React.createElement("text", {
    id: "text4",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan62 || (_tspan62 = /*#__PURE__*/React.createElement("tspan", {
    x: 299.539,
    y: 406.785
  }, "71.3"))), /*#__PURE__*/React.createElement("text", {
    id: "text5",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan63 || (_tspan63 = /*#__PURE__*/React.createElement("tspan", {
    x: 299.539,
    y: 451.065
  }, "109"))), /*#__PURE__*/React.createElement("text", {
    id: "text6",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan64 || (_tspan64 = /*#__PURE__*/React.createElement("tspan", {
    x: 299.539,
    y: 495.335
  }, "18.8"))), /*#__PURE__*/React.createElement("text", {
    id: "text7",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan65 || (_tspan65 = /*#__PURE__*/React.createElement("tspan", {
    x: 299.76,
    y: 539.605
  }, "0.76"))), /*#__PURE__*/React.createElement("text", {
    id: "text8",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan66 || (_tspan66 = /*#__PURE__*/React.createElement("tspan", {
    x: 299.539,
    y: 581.875
  }, "6.92"))), /*#__PURE__*/React.createElement("text", {
    id: "text9",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan67 || (_tspan67 = /*#__PURE__*/React.createElement("tspan", {
    x: 298.59,
    y: 623.155
  }, "61.8  "))), /*#__PURE__*/React.createElement("text", {
    id: "text10",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan68 || (_tspan68 = /*#__PURE__*/React.createElement("tspan", {
    x: 344.039,
    y: 273.965
  }, "1.5"))), /*#__PURE__*/React.createElement("text", {
    id: "text11",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan69 || (_tspan69 = /*#__PURE__*/React.createElement("tspan", {
    x: 344.039,
    y: 318.245
  }, "1.33"))), /*#__PURE__*/React.createElement("text", {
    id: "text12",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan70 || (_tspan70 = /*#__PURE__*/React.createElement("tspan", {
    x: 346.08,
    y: 362.515
  }, "0.92"))), /*#__PURE__*/React.createElement("text", {
    id: "text13",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan71 || (_tspan71 = /*#__PURE__*/React.createElement("tspan", {
    x: 343.82,
    y: 406.785
  }, "71.5"))), /*#__PURE__*/React.createElement("text", {
    id: "text14",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan72 || (_tspan72 = /*#__PURE__*/React.createElement("tspan", {
    x: 351.051,
    y: 451.065
  }, "110"))), /*#__PURE__*/React.createElement("text", {
    id: "text15",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan73 || (_tspan73 = /*#__PURE__*/React.createElement("tspan", {
    x: 344.029,
    y: 495.335
  }, "18.8"))), /*#__PURE__*/React.createElement("text", {
    id: "text16",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan74 || (_tspan74 = /*#__PURE__*/React.createElement("tspan", {
    x: 344.039,
    y: 539.605
  }, "0.77"))), /*#__PURE__*/React.createElement("text", {
    id: "text17",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan75 || (_tspan75 = /*#__PURE__*/React.createElement("tspan", {
    x: 351.82,
    y: 581.875
  }, "7"))), /*#__PURE__*/React.createElement("text", {
    id: "text18",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan76 || (_tspan76 = /*#__PURE__*/React.createElement("tspan", {
    x: 343.82,
    y: 623.155
  }, "63.9"))), /*#__PURE__*/React.createElement("text", {
    id: "text19",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan77 || (_tspan77 = /*#__PURE__*/React.createElement("tspan", {
    x: 388.311,
    y: 273.965
  }, "1.61"))), /*#__PURE__*/React.createElement("text", {
    id: "text20",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan78 || (_tspan78 = /*#__PURE__*/React.createElement("tspan", {
    x: 388.09,
    y: 318.245
  }, "1.4"))), /*#__PURE__*/React.createElement("text", {
    id: "text21",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan79 || (_tspan79 = /*#__PURE__*/React.createElement("tspan", {
    x: 388.09,
    y: 362.515
  }, "0.91"))), /*#__PURE__*/React.createElement("text", {
    id: "text22",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan80 || (_tspan80 = /*#__PURE__*/React.createElement("tspan", {
    x: 388.311,
    y: 406.785
  }, "74.4"))), /*#__PURE__*/React.createElement("text", {
    id: "text23",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan81 || (_tspan81 = /*#__PURE__*/React.createElement("tspan", {
    x: 388.09,
    y: 451.065
  }, "107"))), /*#__PURE__*/React.createElement("text", {
    id: "text24",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan82 || (_tspan82 = /*#__PURE__*/React.createElement("tspan", {
    x: 388.09,
    y: 495.335
  }, "22.1"))), /*#__PURE__*/React.createElement("text", {
    id: "text25",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan83 || (_tspan83 = /*#__PURE__*/React.createElement("tspan", {
    x: 388.09,
    y: 539.605
  }, "0.81"))), /*#__PURE__*/React.createElement("text", {
    id: "text26",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan84 || (_tspan84 = /*#__PURE__*/React.createElement("tspan", {
    x: 388.09,
    y: 581.875
  }, "7.02"))), /*#__PURE__*/React.createElement("text", {
    id: "text27",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan85 || (_tspan85 = /*#__PURE__*/React.createElement("tspan", {
    x: 388.311,
    y: 623.155
  }, "73.1"))), /*#__PURE__*/React.createElement("text", {
    id: "text28",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan86 || (_tspan86 = /*#__PURE__*/React.createElement("tspan", {
    x: 432.359,
    y: 273.965
  }, "1.59"))), /*#__PURE__*/React.createElement("text", {
    id: "text29",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan87 || (_tspan87 = /*#__PURE__*/React.createElement("tspan", {
    x: 432.58,
    y: 318.245
  }, "1.41"))), /*#__PURE__*/React.createElement("text", {
    id: "text30",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan88 || (_tspan88 = /*#__PURE__*/React.createElement("tspan", {
    x: 432.359,
    y: 362.515
  }, "0.92"))), /*#__PURE__*/React.createElement("text", {
    id: "text31",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan89 || (_tspan89 = /*#__PURE__*/React.createElement("tspan", {
    x: 432.58,
    y: 406.785
  }, "76.2"))), /*#__PURE__*/React.createElement("text", {
    id: "text32",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan90 || (_tspan90 = /*#__PURE__*/React.createElement("tspan", {
    x: 432.58,
    y: 451.065
  }, "108"))), /*#__PURE__*/React.createElement("text", {
    id: "text33",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan91 || (_tspan91 = /*#__PURE__*/React.createElement("tspan", {
    x: 432.359,
    y: 495.335
  }, "24.1"))), /*#__PURE__*/React.createElement("text", {
    id: "text34",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan92 || (_tspan92 = /*#__PURE__*/React.createElement("tspan", {
    x: 432.359,
    y: 539.605
  }, "0.81"))), /*#__PURE__*/React.createElement("text", {
    id: "text35",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan93 || (_tspan93 = /*#__PURE__*/React.createElement("tspan", {
    x: 432.58,
    y: 581.875
  }, "7.07"))), /*#__PURE__*/React.createElement("text", {
    id: "text36",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan94 || (_tspan94 = /*#__PURE__*/React.createElement("tspan", {
    x: 432.359,
    y: 623.155
  }, "75.2"))), /*#__PURE__*/React.createElement("text", {
    id: "text37",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan95 || (_tspan95 = /*#__PURE__*/React.createElement("tspan", {
    x: 476.641,
    y: 273.965
  }, "1.54"))), /*#__PURE__*/React.createElement("text", {
    id: "text38",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan96 || (_tspan96 = /*#__PURE__*/React.createElement("tspan", {
    x: 480.68,
    y: 318.245
  }, "1.4"))), /*#__PURE__*/React.createElement("text", {
    id: "text39",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan97 || (_tspan97 = /*#__PURE__*/React.createElement("tspan", {
    x: 476.641,
    y: 362.515
  }, "0.92"))), /*#__PURE__*/React.createElement("text", {
    id: "text40",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan98 || (_tspan98 = /*#__PURE__*/React.createElement("tspan", {
    x: 476.85,
    y: 406.785
  }, "75.7"))), /*#__PURE__*/React.createElement("text", {
    id: "text41",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan99 || (_tspan99 = /*#__PURE__*/React.createElement("tspan", {
    x: 476.85,
    y: 451.065
  }, "107"))), /*#__PURE__*/React.createElement("text", {
    id: "text42",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan100 || (_tspan100 = /*#__PURE__*/React.createElement("tspan", {
    x: 476.85,
    y: 495.335
  }, "23.3"))), /*#__PURE__*/React.createElement("text", {
    id: "text43",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan101 || (_tspan101 = /*#__PURE__*/React.createElement("tspan", {
    x: 476.641,
    y: 539.605
  }, "0.81"))), /*#__PURE__*/React.createElement("text", {
    id: "text44",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan102 || (_tspan102 = /*#__PURE__*/React.createElement("tspan", {
    x: 476.641,
    y: 581.875
  }, "7.11"))), /*#__PURE__*/React.createElement("text", {
    id: "text45",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan103 || (_tspan103 = /*#__PURE__*/React.createElement("tspan", {
    x: 476.641,
    y: 623.155
  }, "72.6"))), /*#__PURE__*/React.createElement("text", {
    id: "text46",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan104 || (_tspan104 = /*#__PURE__*/React.createElement("tspan", {
    x: 521.129,
    y: 273.965
  }, "1.45"))), /*#__PURE__*/React.createElement("text", {
    id: "text47",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan105 || (_tspan105 = /*#__PURE__*/React.createElement("tspan", {
    x: 520.91,
    y: 318.245
  }, "1.36"))), /*#__PURE__*/React.createElement("text", {
    id: "text48",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan106 || (_tspan106 = /*#__PURE__*/React.createElement("tspan", {
    x: 520.91,
    y: 362.515
  }, "0.89"))), /*#__PURE__*/React.createElement("text", {
    id: "text49",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan107 || (_tspan107 = /*#__PURE__*/React.createElement("tspan", {
    x: 520.91,
    y: 406.785
  }, "75.7"))), /*#__PURE__*/React.createElement("text", {
    id: "text50",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan108 || (_tspan108 = /*#__PURE__*/React.createElement("tspan", {
    x: 524.949,
    y: 451.065
  }, "108"))), /*#__PURE__*/React.createElement("text", {
    id: "text51",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan109 || (_tspan109 = /*#__PURE__*/React.createElement("tspan", {
    x: 521.129,
    y: 495.335
  }, "22.2"))), /*#__PURE__*/React.createElement("text", {
    id: "text52",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan110 || (_tspan110 = /*#__PURE__*/React.createElement("tspan", {
    x: 520.91,
    y: 539.605
  }, "0.8"))), /*#__PURE__*/React.createElement("text", {
    id: "text53",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan111 || (_tspan111 = /*#__PURE__*/React.createElement("tspan", {
    x: 520.91,
    y: 581.875
  }, "7.09"))), /*#__PURE__*/React.createElement("text", {
    id: "text54",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan112 || (_tspan112 = /*#__PURE__*/React.createElement("tspan", {
    x: 520.91,
    y: 623.155
  }, "69.2"))), /*#__PURE__*/React.createElement("text", {
    id: "text55",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan113 || (_tspan113 = /*#__PURE__*/React.createElement("tspan", {
    x: 565.18,
    y: 273.965
  }, "1.42"))), /*#__PURE__*/React.createElement("text", {
    id: "text56",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan114 || (_tspan114 = /*#__PURE__*/React.createElement("tspan", {
    x: 565.4,
    y: 318.245
  }, "1.35"))), /*#__PURE__*/React.createElement("text", {
    id: "text57",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan115 || (_tspan115 = /*#__PURE__*/React.createElement("tspan", {
    x: 565.18,
    y: 362.515
  }, "0.87"))), /*#__PURE__*/React.createElement("text", {
    id: "text58",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan116 || (_tspan116 = /*#__PURE__*/React.createElement("tspan", {
    x: 568.4,
    y: 406.785
  }, "75"))), /*#__PURE__*/React.createElement("text", {
    id: "text59",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan117 || (_tspan117 = /*#__PURE__*/React.createElement("tspan", {
    x: 565.18,
    y: 451.065
  }, "107"))), /*#__PURE__*/React.createElement("text", {
    id: "text60",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan118 || (_tspan118 = /*#__PURE__*/React.createElement("tspan", {
    x: 565.4,
    y: 495.335
  }, "22.3"))), /*#__PURE__*/React.createElement("text", {
    id: "text61",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan119 || (_tspan119 = /*#__PURE__*/React.createElement("tspan", {
    x: 569.439,
    y: 539.605
  }, "0.79"))), /*#__PURE__*/React.createElement("text", {
    id: "text62",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan120 || (_tspan120 = /*#__PURE__*/React.createElement("tspan", {
    x: 565.4,
    y: 581.875
  }, "7.01"))), /*#__PURE__*/React.createElement("text", {
    id: "text63",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan121 || (_tspan121 = /*#__PURE__*/React.createElement("tspan", {
    x: 565.18,
    y: 623.155
  }, "71.3"))), /*#__PURE__*/React.createElement("text", {
    id: "text64",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan122 || (_tspan122 = /*#__PURE__*/React.createElement("tspan", {
    x: 609.449,
    y: 273.965
  }, "1.39"))), /*#__PURE__*/React.createElement("text", {
    id: "text65",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan123 || (_tspan123 = /*#__PURE__*/React.createElement("tspan", {
    x: 609.449,
    y: 318.245
  }, "1.32"))), /*#__PURE__*/React.createElement("text", {
    id: "text66",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan124 || (_tspan124 = /*#__PURE__*/React.createElement("tspan", {
    x: 609.449,
    y: 362.515
  }, "0.85"))), /*#__PURE__*/React.createElement("text", {
    id: "text67",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan125 || (_tspan125 = /*#__PURE__*/React.createElement("tspan", {
    x: 609.67,
    y: 406.785
  }, "74.7"))), /*#__PURE__*/React.createElement("text", {
    id: "text68",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan126 || (_tspan126 = /*#__PURE__*/React.createElement("tspan", {
    x: 609.449,
    y: 451.065
  }, "106"))), /*#__PURE__*/React.createElement("text", {
    id: "text69",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan127 || (_tspan127 = /*#__PURE__*/React.createElement("tspan", {
    x: 609.67,
    y: 495.335
  }, "22.1"))), /*#__PURE__*/React.createElement("text", {
    id: "text70",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan128 || (_tspan128 = /*#__PURE__*/React.createElement("tspan", {
    x: 609.449,
    y: 539.605
  }, "0.76"))), /*#__PURE__*/React.createElement("text", {
    id: "text71",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan129 || (_tspan129 = /*#__PURE__*/React.createElement("tspan", {
    x: 609.449,
    y: 581.875
  }, "6.93"))), /*#__PURE__*/React.createElement("text", {
    id: "text72",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan130 || (_tspan130 = /*#__PURE__*/React.createElement("tspan", {
    x: 609.67,
    y: 623.155
  }, "73.8"))), /*#__PURE__*/React.createElement("text", {
    id: "text73",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan131 || (_tspan131 = /*#__PURE__*/React.createElement("tspan", {
    x: 653.73,
    y: 273.965
  }, "1.38"))), /*#__PURE__*/React.createElement("text", {
    id: "text74",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan132 || (_tspan132 = /*#__PURE__*/React.createElement("tspan", {
    x: 653.73,
    y: 318.245
  }, "1.32"))), /*#__PURE__*/React.createElement("text", {
    id: "text75",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan133 || (_tspan133 = /*#__PURE__*/React.createElement("tspan", {
    x: 653.73,
    y: 362.515
  }, "0.85"))), /*#__PURE__*/React.createElement("text", {
    id: "text76",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan134 || (_tspan134 = /*#__PURE__*/React.createElement("tspan", {
    x: 653.939,
    y: 406.785
  }, "73.5"))), /*#__PURE__*/React.createElement("text", {
    id: "text77",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan135 || (_tspan135 = /*#__PURE__*/React.createElement("tspan", {
    x: 653.73,
    y: 451.065
  }, "106"))), /*#__PURE__*/React.createElement("text", {
    id: "text78",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan136 || (_tspan136 = /*#__PURE__*/React.createElement("tspan", {
    x: 653.939,
    y: 495.335
  }, "21.5"))), /*#__PURE__*/React.createElement("text", {
    id: "text79",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan137 || (_tspan137 = /*#__PURE__*/React.createElement("tspan", {
    x: 653.939,
    y: 539.605
  }, "0.77"))), /*#__PURE__*/React.createElement("text", {
    id: "text80",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan138 || (_tspan138 = /*#__PURE__*/React.createElement("tspan", {
    x: 653.73,
    y: 581.875
  }, "6.81"))), /*#__PURE__*/React.createElement("text", {
    id: "text81",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan139 || (_tspan139 = /*#__PURE__*/React.createElement("tspan", {
    x: 653.73,
    y: 623.155
  }, "75.7"))), /*#__PURE__*/React.createElement("text", {
    id: "text82",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan140 || (_tspan140 = /*#__PURE__*/React.createElement("tspan", {
    x: 702.039,
    y: 273.965
  }, "1.4"))), /*#__PURE__*/React.createElement("text", {
    id: "text83",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan141 || (_tspan141 = /*#__PURE__*/React.createElement("tspan", {
    x: 698,
    y: 318.245
  }, "1.32"))), /*#__PURE__*/React.createElement("text", {
    id: "text84",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan142 || (_tspan142 = /*#__PURE__*/React.createElement("tspan", {
    x: 698.221,
    y: 362.515
  }, "0.85"))), /*#__PURE__*/React.createElement("text", {
    id: "text85",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan143 || (_tspan143 = /*#__PURE__*/React.createElement("tspan", {
    x: 698,
    y: 406.785
  }, "73.5"))), /*#__PURE__*/React.createElement("text", {
    id: "text86",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan144 || (_tspan144 = /*#__PURE__*/React.createElement("tspan", {
    x: 698,
    y: 451.065
  }, "105"))), /*#__PURE__*/React.createElement("text", {
    id: "text87",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan145 || (_tspan145 = /*#__PURE__*/React.createElement("tspan", {
    x: 700.039,
    y: 495.335
  }, "21.2"))), /*#__PURE__*/React.createElement("text", {
    id: "text88",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan146 || (_tspan146 = /*#__PURE__*/React.createElement("tspan", {
    x: 698.221,
    y: 539.605
  }, "0.77"))), /*#__PURE__*/React.createElement("text", {
    id: "text89",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan147 || (_tspan147 = /*#__PURE__*/React.createElement("tspan", {
    x: 698,
    y: 581.875
  }, "6.7"))), /*#__PURE__*/React.createElement("text", {
    id: "text90",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan148 || (_tspan148 = /*#__PURE__*/React.createElement("tspan", {
    x: 698.221,
    y: 623.155
  }, "77.6"))), /*#__PURE__*/React.createElement("text", {
    id: "text91",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan149 || (_tspan149 = /*#__PURE__*/React.createElement("tspan", {
    x: 742.27,
    y: 273.965
  }, "1.38"))), /*#__PURE__*/React.createElement("text", {
    id: "text92",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan150 || (_tspan150 = /*#__PURE__*/React.createElement("tspan", {
    x: 742.49,
    y: 318.245
  }, "1.31"))), /*#__PURE__*/React.createElement("text", {
    id: "text93",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan151 || (_tspan151 = /*#__PURE__*/React.createElement("tspan", {
    x: 742.27,
    y: 362.515
  }, "0.85"))), /*#__PURE__*/React.createElement("text", {
    id: "text94",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan152 || (_tspan152 = /*#__PURE__*/React.createElement("tspan", {
    x: 742.27,
    y: 406.785
  }, "74.2"))), /*#__PURE__*/React.createElement("text", {
    id: "text95",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan153 || (_tspan153 = /*#__PURE__*/React.createElement("tspan", {
    x: 742.27,
    y: 451.065
  }, "104"))), /*#__PURE__*/React.createElement("text", {
    id: "text96",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan154 || (_tspan154 = /*#__PURE__*/React.createElement("tspan", {
    x: 742.49,
    y: 495.335
  }, "20.4"))), /*#__PURE__*/React.createElement("text", {
    id: "text97",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan155 || (_tspan155 = /*#__PURE__*/React.createElement("tspan", {
    x: 742.27,
    y: 539.605
  }, "0.76"))), /*#__PURE__*/React.createElement("text", {
    id: "text98",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan156 || (_tspan156 = /*#__PURE__*/React.createElement("tspan", {
    x: 742.27,
    y: 581.875
  }, "6.61"))), /*#__PURE__*/React.createElement("text", {
    id: "text99",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan157 || (_tspan157 = /*#__PURE__*/React.createElement("tspan", {
    x: 742.27,
    y: 623.155
  }, "77"))), /*#__PURE__*/React.createElement("text", {
    id: "text100",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan158 || (_tspan158 = /*#__PURE__*/React.createElement("tspan", {
    x: 786.76,
    y: 273.965
  }, "1.33"))), /*#__PURE__*/React.createElement("text", {
    id: "text101",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan159 || (_tspan159 = /*#__PURE__*/React.createElement("tspan", {
    x: 786.539,
    y: 318.245
  }, "1.28"))), /*#__PURE__*/React.createElement("text", {
    id: "text102",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan160 || (_tspan160 = /*#__PURE__*/React.createElement("tspan", {
    x: 786.539,
    y: 362.515
  }, "0.82"))), /*#__PURE__*/React.createElement("text", {
    id: "text103",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan161 || (_tspan161 = /*#__PURE__*/React.createElement("tspan", {
    x: 786.539,
    y: 406.785
  }, "73.6"))), /*#__PURE__*/React.createElement("text", {
    id: "text104",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan162 || (_tspan162 = /*#__PURE__*/React.createElement("tspan", {
    x: 786.539,
    y: 451.065
  }, "104"))), /*#__PURE__*/React.createElement("text", {
    id: "text105",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan163 || (_tspan163 = /*#__PURE__*/React.createElement("tspan", {
    x: 786.539,
    y: 495.335
  }, "19.9"))), /*#__PURE__*/React.createElement("text", {
    id: "text106",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan164 || (_tspan164 = /*#__PURE__*/React.createElement("tspan", {
    x: 786.539,
    y: 539.605
  }, "0.74"))), /*#__PURE__*/React.createElement("text", {
    id: "text107",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan165 || (_tspan165 = /*#__PURE__*/React.createElement("tspan", {
    x: 786.539,
    y: 581.875
  }, "6.54"))), /*#__PURE__*/React.createElement("text", {
    id: "text108",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan166 || (_tspan166 = /*#__PURE__*/React.createElement("tspan", {
    x: 786.539,
    y: 623.155
  }, "74.1"))), /*#__PURE__*/React.createElement("text", {
    id: "text109",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan167 || (_tspan167 = /*#__PURE__*/React.createElement("tspan", {
    x: 830.82,
    y: 273.965
  }, "1.29"))), /*#__PURE__*/React.createElement("text", {
    id: "text110",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan168 || (_tspan168 = /*#__PURE__*/React.createElement("tspan", {
    x: 830.82,
    y: 318.245
  }, "1.27"))), /*#__PURE__*/React.createElement("text", {
    id: "text111",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan169 || (_tspan169 = /*#__PURE__*/React.createElement("tspan", {
    x: 830.82,
    y: 362.515
  }, "0.82"))), /*#__PURE__*/React.createElement("text", {
    id: "text112",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan170 || (_tspan170 = /*#__PURE__*/React.createElement("tspan", {
    x: 830.82,
    y: 406.785
  }, "73.1"))), /*#__PURE__*/React.createElement("text", {
    id: "text113",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan171 || (_tspan171 = /*#__PURE__*/React.createElement("tspan", {
    x: 831.039,
    y: 451.065
  }, "104"))), /*#__PURE__*/React.createElement("text", {
    id: "text114",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan172 || (_tspan172 = /*#__PURE__*/React.createElement("tspan", {
    x: 830.82,
    y: 495.335
  }, "19.8"))), /*#__PURE__*/React.createElement("text", {
    id: "text115",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan173 || (_tspan173 = /*#__PURE__*/React.createElement("tspan", {
    x: 831.039,
    y: 539.605
  }, "0.73"))), /*#__PURE__*/React.createElement("text", {
    id: "text116",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan174 || (_tspan174 = /*#__PURE__*/React.createElement("tspan", {
    x: 830.82,
    y: 581.875
  }, "6.47"))), /*#__PURE__*/React.createElement("text", {
    id: "text117",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan175 || (_tspan175 = /*#__PURE__*/React.createElement("tspan", {
    x: 830.82,
    y: 623.155
  }, "74.2"))), /*#__PURE__*/React.createElement("text", {
    id: "text118",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan176 || (_tspan176 = /*#__PURE__*/React.createElement("tspan", {
    x: 875.09,
    y: 273.965
  }, "1.29"))), /*#__PURE__*/React.createElement("text", {
    id: "text119",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan177 || (_tspan177 = /*#__PURE__*/React.createElement("tspan", {
    x: 875.311,
    y: 318.245
  }, "1.27"))), /*#__PURE__*/React.createElement("text", {
    id: "text120",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan178 || (_tspan178 = /*#__PURE__*/React.createElement("tspan", {
    x: 875.311,
    y: 362.515
  }, "0.83"))), /*#__PURE__*/React.createElement("text", {
    id: "text121",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan179 || (_tspan179 = /*#__PURE__*/React.createElement("tspan", {
    x: 876.129,
    y: 406.785
  }, "72.8"))), /*#__PURE__*/React.createElement("text", {
    id: "text122",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan180 || (_tspan180 = /*#__PURE__*/React.createElement("tspan", {
    x: 875.09,
    y: 451.065
  }, "105"))), /*#__PURE__*/React.createElement("text", {
    id: "text123",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan181 || (_tspan181 = /*#__PURE__*/React.createElement("tspan", {
    x: 875.09,
    y: 495.335
  }, "20.2"))), /*#__PURE__*/React.createElement("text", {
    id: "text124",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan182 || (_tspan182 = /*#__PURE__*/React.createElement("tspan", {
    x: 875.09,
    y: 539.605
  }, "0.72"))), /*#__PURE__*/React.createElement("text", {
    id: "text125",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan183 || (_tspan183 = /*#__PURE__*/React.createElement("tspan", {
    x: 875.09,
    y: 581.875
  }, "6.46"))), /*#__PURE__*/React.createElement("text", {
    id: "text126",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan184 || (_tspan184 = /*#__PURE__*/React.createElement("tspan", {
    x: 875.311,
    y: 623.155
  }, "74.4"))), /*#__PURE__*/React.createElement("text", {
    id: "text127",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan185 || (_tspan185 = /*#__PURE__*/React.createElement("tspan", {
    x: 919.58,
    y: 273.965
  }, "1.3"))), /*#__PURE__*/React.createElement("text", {
    id: "text128",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan186 || (_tspan186 = /*#__PURE__*/React.createElement("tspan", {
    x: 919.359,
    y: 318.245
  }, "1.26"))), /*#__PURE__*/React.createElement("text", {
    id: "text129",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan187 || (_tspan187 = /*#__PURE__*/React.createElement("tspan", {
    x: 919.359,
    y: 362.515
  }, "0.84"))), /*#__PURE__*/React.createElement("text", {
    id: "text130",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan188 || (_tspan188 = /*#__PURE__*/React.createElement("tspan", {
    x: 919.359,
    y: 406.785
  }, "72.8"))), /*#__PURE__*/React.createElement("text", {
    id: "text131",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan189 || (_tspan189 = /*#__PURE__*/React.createElement("tspan", {
    x: 919.359,
    y: 451.065
  }, "109"))), /*#__PURE__*/React.createElement("text", {
    id: "text132",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan190 || (_tspan190 = /*#__PURE__*/React.createElement("tspan", {
    x: 919.58,
    y: 495.335
  }, "20.7"))), /*#__PURE__*/React.createElement("text", {
    id: "text133",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan191 || (_tspan191 = /*#__PURE__*/React.createElement("tspan", {
    x: 919.58,
    y: 539.605
  }, "0.72"))), /*#__PURE__*/React.createElement("text", {
    id: "text134",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan192 || (_tspan192 = /*#__PURE__*/React.createElement("tspan", {
    x: 919.359,
    y: 581.875
  }, "6.51"))), /*#__PURE__*/React.createElement("text", {
    id: "text135",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan193 || (_tspan193 = /*#__PURE__*/React.createElement("tspan", {
    x: 919.359,
    y: 623.155
  }, "74.4"))), /*#__PURE__*/React.createElement("text", {
    id: "text136",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan194 || (_tspan194 = /*#__PURE__*/React.createElement("tspan", {
    x: 967.891,
    y: 273.965
  }, "1.3"))), /*#__PURE__*/React.createElement("text", {
    id: "text137",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan195 || (_tspan195 = /*#__PURE__*/React.createElement("tspan", {
    x: 963.85,
    y: 318.245
  }, "1.25"))), /*#__PURE__*/React.createElement("text", {
    id: "text138",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan196 || (_tspan196 = /*#__PURE__*/React.createElement("tspan", {
    x: 963.629,
    y: 362.515
  }, "0.84"))), /*#__PURE__*/React.createElement("text", {
    id: "text139",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan197 || (_tspan197 = /*#__PURE__*/React.createElement("tspan", {
    x: 963.85,
    y: 406.785
  }, "74.5"))), /*#__PURE__*/React.createElement("text", {
    id: "text140",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan198 || (_tspan198 = /*#__PURE__*/React.createElement("tspan", {
    x: 963.629,
    y: 451.065
  }, "109"))), /*#__PURE__*/React.createElement("text", {
    id: "text141",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan199 || (_tspan199 = /*#__PURE__*/React.createElement("tspan", {
    x: 963.629,
    y: 495.335
  }, "20"))), /*#__PURE__*/React.createElement("text", {
    id: "text142",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan200 || (_tspan200 = /*#__PURE__*/React.createElement("tspan", {
    x: 963.85,
    y: 539.605
  }, "0.72"))), /*#__PURE__*/React.createElement("text", {
    id: "text143",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan201 || (_tspan201 = /*#__PURE__*/React.createElement("tspan", {
    x: 963.629,
    y: 581.875
  }, "6.52"))), /*#__PURE__*/React.createElement("text", {
    id: "text144",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan202 || (_tspan202 = /*#__PURE__*/React.createElement("tspan", {
    x: 963.629,
    y: 623.155
  }, "76.1"))), /*#__PURE__*/React.createElement("text", {
    id: "text145",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan203 || (_tspan203 = /*#__PURE__*/React.createElement("tspan", {
    x: 1008.12,
    y: 273.965
  }, "1.29"))), /*#__PURE__*/React.createElement("text", {
    id: "text146",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan204 || (_tspan204 = /*#__PURE__*/React.createElement("tspan", {
    x: 1008.12,
    y: 318.245
  }, "1.21"))), /*#__PURE__*/React.createElement("text", {
    id: "text147",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan205 || (_tspan205 = /*#__PURE__*/React.createElement("tspan", {
    x: 1007.9,
    y: 362.515
  }, "0.82"))), /*#__PURE__*/React.createElement("text", {
    id: "text148",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan206 || (_tspan206 = /*#__PURE__*/React.createElement("tspan", {
    x: 1007.9,
    y: 406.785
  }, "73.3"))), /*#__PURE__*/React.createElement("text", {
    id: "text149",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan207 || (_tspan207 = /*#__PURE__*/React.createElement("tspan", {
    x: 1008.12,
    y: 451.065
  }, "109"))), /*#__PURE__*/React.createElement("text", {
    id: "text150",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan208 || (_tspan208 = /*#__PURE__*/React.createElement("tspan", {
    x: 1008.12,
    y: 495.335
  }, "19.9"))), /*#__PURE__*/React.createElement("text", {
    id: "text151",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan209 || (_tspan209 = /*#__PURE__*/React.createElement("tspan", {
    x: 1008.12,
    y: 539.605
  }, "0.71"))), /*#__PURE__*/React.createElement("text", {
    id: "text152",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan210 || (_tspan210 = /*#__PURE__*/React.createElement("tspan", {
    x: 1007.9,
    y: 581.875
  }, "6.43"))), /*#__PURE__*/React.createElement("text", {
    id: "text153",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan211 || (_tspan211 = /*#__PURE__*/React.createElement("tspan", {
    x: 1007.9,
    y: 623.155
  }, "74"))), /*#__PURE__*/React.createElement("text", {
    id: "text154",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan212 || (_tspan212 = /*#__PURE__*/React.createElement("tspan", {
    x: 1052.4,
    y: 273.965
  }, "1.31"))), /*#__PURE__*/React.createElement("text", {
    id: "text155",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan213 || (_tspan213 = /*#__PURE__*/React.createElement("tspan", {
    x: 1052.18,
    y: 318.245
  }, "1.22"))), /*#__PURE__*/React.createElement("text", {
    id: "text156",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan214 || (_tspan214 = /*#__PURE__*/React.createElement("tspan", {
    x: 1054.44,
    y: 362.515
  }, "0.83"))), /*#__PURE__*/React.createElement("text", {
    id: "text157",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan215 || (_tspan215 = /*#__PURE__*/React.createElement("tspan", {
    x: 1052.18,
    y: 406.785
  }, "73.6"))), /*#__PURE__*/React.createElement("text", {
    id: "text158",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan216 || (_tspan216 = /*#__PURE__*/React.createElement("tspan", {
    x: 1054,
    y: 451.455
  }, "110"))), /*#__PURE__*/React.createElement("text", {
    id: "text159",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan217 || (_tspan217 = /*#__PURE__*/React.createElement("tspan", {
    x: 1052.18,
    y: 495.335
  }, "19.9"))), /*#__PURE__*/React.createElement("text", {
    id: "text160",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan218 || (_tspan218 = /*#__PURE__*/React.createElement("tspan", {
    x: 1052.18,
    y: 539.605
  }, "0.71"))), /*#__PURE__*/React.createElement("text", {
    id: "text161",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan219 || (_tspan219 = /*#__PURE__*/React.createElement("tspan", {
    x: 1052.4,
    y: 581.875
  }, "6.42"))), /*#__PURE__*/React.createElement("text", {
    id: "text162",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan220 || (_tspan220 = /*#__PURE__*/React.createElement("tspan", {
    x: 1052.4,
    y: 623.155
  }, "72.5"))), /*#__PURE__*/React.createElement("text", {
    id: "text163",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan221 || (_tspan221 = /*#__PURE__*/React.createElement("tspan", {
    x: 1096.67,
    y: 273.965
  }, "1.35"))), /*#__PURE__*/React.createElement("text", {
    id: "text164",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan222 || (_tspan222 = /*#__PURE__*/React.createElement("tspan", {
    x: 1096.67,
    y: 318.245
  }, "1.25"))), /*#__PURE__*/React.createElement("text", {
    id: "text165",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan223 || (_tspan223 = /*#__PURE__*/React.createElement("tspan", {
    x: 1098.71,
    y: 362.515
  }, "0.85"))), /*#__PURE__*/React.createElement("text", {
    id: "text166",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan224 || (_tspan224 = /*#__PURE__*/React.createElement("tspan", {
    x: 1096.45,
    y: 406.785
  }, "74.5"))), /*#__PURE__*/React.createElement("text", {
    id: "text167",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan225 || (_tspan225 = /*#__PURE__*/React.createElement("tspan", {
    x: 1096.45,
    y: 451.065
  }, "110"))), /*#__PURE__*/React.createElement("text", {
    id: "text168",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan226 || (_tspan226 = /*#__PURE__*/React.createElement("tspan", {
    x: 1096.67,
    y: 495.335
  }, "19.9"))), /*#__PURE__*/React.createElement("text", {
    id: "text169",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan227 || (_tspan227 = /*#__PURE__*/React.createElement("tspan", {
    x: 1096.67,
    y: 539.605
  }, "0.72"))), /*#__PURE__*/React.createElement("text", {
    id: "text170",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan228 || (_tspan228 = /*#__PURE__*/React.createElement("tspan", {
    x: 1096.45,
    y: 581.875
  }, "6.47"))), /*#__PURE__*/React.createElement("text", {
    id: "text171",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan229 || (_tspan229 = /*#__PURE__*/React.createElement("tspan", {
    x: 1096.67,
    y: 623.155
  }, "73.9"))), /*#__PURE__*/React.createElement("text", {
    id: "text172",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan230 || (_tspan230 = /*#__PURE__*/React.createElement("tspan", {
    x: 1140.72,
    y: 273.965
  }, "1.37"))), /*#__PURE__*/React.createElement("text", {
    id: "text173",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan231 || (_tspan231 = /*#__PURE__*/React.createElement("tspan", {
    x: 1140.72,
    y: 318.245
  }, "1.26"))), /*#__PURE__*/React.createElement("text", {
    id: "text174",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan232 || (_tspan232 = /*#__PURE__*/React.createElement("tspan", {
    x: 1142.98,
    y: 362.515
  }, "0.85"))), /*#__PURE__*/React.createElement("text", {
    id: "text175",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan233 || (_tspan233 = /*#__PURE__*/React.createElement("tspan", {
    x: 1142.43,
    y: 406.785
  }, "74.2"))), /*#__PURE__*/React.createElement("text", {
    id: "text176",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan234 || (_tspan234 = /*#__PURE__*/React.createElement("tspan", {
    x: 1140.72,
    y: 451.065
  }, "110"))), /*#__PURE__*/React.createElement("text", {
    id: "text177",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan235 || (_tspan235 = /*#__PURE__*/React.createElement("tspan", {
    x: 1140.72,
    y: 495.335
  }, "20"))), /*#__PURE__*/React.createElement("text", {
    id: "text178",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan236 || (_tspan236 = /*#__PURE__*/React.createElement("tspan", {
    x: 1140.72,
    y: 539.605
  }, "0.72"))), /*#__PURE__*/React.createElement("text", {
    id: "text179",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan237 || (_tspan237 = /*#__PURE__*/React.createElement("tspan", {
    x: 1140.72,
    y: 581.875
  }, "6.48"))), /*#__PURE__*/React.createElement("text", {
    id: "text180",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan238 || (_tspan238 = /*#__PURE__*/React.createElement("tspan", {
    x: 1140.94,
    y: 623.155
  }, "73.6"))), /*#__PURE__*/React.createElement("text", {
    id: "text181",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan239 || (_tspan239 = /*#__PURE__*/React.createElement("tspan", {
    x: 1185,
    y: 273.965
  }, "1.37"))), /*#__PURE__*/React.createElement("text", {
    id: "text182",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan240 || (_tspan240 = /*#__PURE__*/React.createElement("tspan", {
    x: 1185,
    y: 318.245
  }, "1.27"))), /*#__PURE__*/React.createElement("text", {
    id: "text183",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan241 || (_tspan241 = /*#__PURE__*/React.createElement("tspan", {
    x: 1189.26,
    y: 362.515
  }, "0.85"))), /*#__PURE__*/React.createElement("text", {
    id: "text184",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan242 || (_tspan242 = /*#__PURE__*/React.createElement("tspan", {
    x: 1184.71,
    y: 406.785
  }, "73.6"))), /*#__PURE__*/React.createElement("text", {
    id: "text185",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan243 || (_tspan243 = /*#__PURE__*/React.createElement("tspan", {
    x: 1185.21,
    y: 451.065
  }, "110"))), /*#__PURE__*/React.createElement("text", {
    id: "text186",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan244 || (_tspan244 = /*#__PURE__*/React.createElement("tspan", {
    x: 1185,
    y: 495.335
  }, "20"))), /*#__PURE__*/React.createElement("text", {
    id: "text187",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan245 || (_tspan245 = /*#__PURE__*/React.createElement("tspan", {
    x: 1185,
    y: 539.605
  }, "0.73"))), /*#__PURE__*/React.createElement("text", {
    id: "text188",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan246 || (_tspan246 = /*#__PURE__*/React.createElement("tspan", {
    x: 1185,
    y: 581.875
  }, "6.46"))), /*#__PURE__*/React.createElement("text", {
    id: "text189",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan247 || (_tspan247 = /*#__PURE__*/React.createElement("tspan", {
    x: 1185.21,
    y: 623.155
  }, "72.9"))), /*#__PURE__*/React.createElement("text", {
    id: "text190",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan248 || (_tspan248 = /*#__PURE__*/React.createElement("tspan", {
    x: 1229.49,
    y: 273.965
  }, "1.35"))), /*#__PURE__*/React.createElement("text", {
    id: "text191",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan249 || (_tspan249 = /*#__PURE__*/React.createElement("tspan", {
    x: 1229.49,
    y: 318.245
  }, "1.24"))), /*#__PURE__*/React.createElement("text", {
    id: "text192",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan250 || (_tspan250 = /*#__PURE__*/React.createElement("tspan", {
    x: 1229.49,
    y: 362.515
  }, "0.86"))), /*#__PURE__*/React.createElement("text", {
    id: "text193",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan251 || (_tspan251 = /*#__PURE__*/React.createElement("tspan", {
    x: 1229.49,
    y: 406.785
  }, "74.9"))), /*#__PURE__*/React.createElement("text", {
    id: "text194",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan252 || (_tspan252 = /*#__PURE__*/React.createElement("tspan", {
    x: 1229.49,
    y: 451.065
  }, "113"))), /*#__PURE__*/React.createElement("text", {
    id: "text195",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan253 || (_tspan253 = /*#__PURE__*/React.createElement("tspan", {
    x: 1229.49,
    y: 495.335
  }, "20.5"))), /*#__PURE__*/React.createElement("text", {
    id: "text196",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan254 || (_tspan254 = /*#__PURE__*/React.createElement("tspan", {
    x: 1229.27,
    y: 539.605
  }, "0.73"))), /*#__PURE__*/React.createElement("text", {
    id: "text197",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan255 || (_tspan255 = /*#__PURE__*/React.createElement("tspan", {
    x: 1229.27,
    y: 581.875
  }, "6.41"))), /*#__PURE__*/React.createElement("text", {
    id: "text198",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan256 || (_tspan256 = /*#__PURE__*/React.createElement("tspan", {
    x: 1229.27,
    y: 623.155
  }, "71.5"))), /*#__PURE__*/React.createElement("text", {
    id: "text199",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan257 || (_tspan257 = /*#__PURE__*/React.createElement("tspan", {
    x: 1273.54,
    y: 273.965
  }, "1.37"))), /*#__PURE__*/React.createElement("text", {
    id: "text200",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan258 || (_tspan258 = /*#__PURE__*/React.createElement("tspan", {
    x: 1273.54,
    y: 318.245
  }, "1.26"))), /*#__PURE__*/React.createElement("text", {
    id: "text201",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan259 || (_tspan259 = /*#__PURE__*/React.createElement("tspan", {
    x: 1273.76,
    y: 362.515
  }, "0.88"))), /*#__PURE__*/React.createElement("text", {
    id: "text202",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan260 || (_tspan260 = /*#__PURE__*/React.createElement("tspan", {
    x: 1273.54,
    y: 406.785
  }, "74.5"))), /*#__PURE__*/React.createElement("text", {
    id: "text203",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan261 || (_tspan261 = /*#__PURE__*/React.createElement("tspan", {
    x: 1273.54,
    y: 451.065
  }, "114"))), /*#__PURE__*/React.createElement("text", {
    id: "text204",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan262 || (_tspan262 = /*#__PURE__*/React.createElement("tspan", {
    x: 1273.54,
    y: 495.335
  }, "20.8"))), /*#__PURE__*/React.createElement("text", {
    id: "text205",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan263 || (_tspan263 = /*#__PURE__*/React.createElement("tspan", {
    x: 1273.76,
    y: 539.605
  }, "0.74"))), /*#__PURE__*/React.createElement("text", {
    id: "text206",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan264 || (_tspan264 = /*#__PURE__*/React.createElement("tspan", {
    x: 1273.76,
    y: 581.875
  }, "6.39"))), /*#__PURE__*/React.createElement("text", {
    id: "text207",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan265 || (_tspan265 = /*#__PURE__*/React.createElement("tspan", {
    x: 1273.54,
    y: 623.155
  }, "72.6"))), /*#__PURE__*/React.createElement("text", {
    id: "text208",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan266 || (_tspan266 = /*#__PURE__*/React.createElement("tspan", {
    x: 1321.86,
    y: 273.965
  }, "1.4"))), /*#__PURE__*/React.createElement("text", {
    id: "text209",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan267 || (_tspan267 = /*#__PURE__*/React.createElement("tspan", {
    x: 1317.81,
    y: 318.245
  }, "1.28"))), /*#__PURE__*/React.createElement("text", {
    id: "text210",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan268 || (_tspan268 = /*#__PURE__*/React.createElement("tspan", {
    x: 1317.81,
    y: 362.515
  }, "0.88"))), /*#__PURE__*/React.createElement("text", {
    id: "text211",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan269 || (_tspan269 = /*#__PURE__*/React.createElement("tspan", {
    x: 1317.81,
    y: 406.785
  }, "75.4"))), /*#__PURE__*/React.createElement("text", {
    id: "text212",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan270 || (_tspan270 = /*#__PURE__*/React.createElement("tspan", {
    x: 1318.03,
    y: 451.065
  }, "114"))), /*#__PURE__*/React.createElement("text", {
    id: "text213",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan271 || (_tspan271 = /*#__PURE__*/React.createElement("tspan", {
    x: 1317.81,
    y: 495.335
  }, "20.8"))), /*#__PURE__*/React.createElement("text", {
    id: "text214",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan272 || (_tspan272 = /*#__PURE__*/React.createElement("tspan", {
    x: 1317.81,
    y: 539.605
  }, "0.75"))), /*#__PURE__*/React.createElement("text", {
    id: "text215",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan273 || (_tspan273 = /*#__PURE__*/React.createElement("tspan", {
    x: 1317.81,
    y: 581.875
  }, "6.37"))), /*#__PURE__*/React.createElement("text", {
    id: "text216",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan274 || (_tspan274 = /*#__PURE__*/React.createElement("tspan", {
    x: 1317.81,
    y: 623.155
  }, "73.7"))), /*#__PURE__*/React.createElement("text", {
    id: "text217",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan275 || (_tspan275 = /*#__PURE__*/React.createElement("tspan", {
    x: 1362.09,
    y: 273.965
  }, "1.39"))), /*#__PURE__*/React.createElement("text", {
    id: "text218",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan276 || (_tspan276 = /*#__PURE__*/React.createElement("tspan", {
    x: 1362.09,
    y: 318.245
  }, "1.26"))), /*#__PURE__*/React.createElement("text", {
    id: "text219",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan277 || (_tspan277 = /*#__PURE__*/React.createElement("tspan", {
    x: 1362.3,
    y: 362.515
  }, "0.88"))), /*#__PURE__*/React.createElement("text", {
    id: "text220",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan278 || (_tspan278 = /*#__PURE__*/React.createElement("tspan", {
    x: 1362.3,
    y: 406.785
  }, "74.4"))), /*#__PURE__*/React.createElement("text", {
    id: "text221",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan279 || (_tspan279 = /*#__PURE__*/React.createElement("tspan", {
    x: 1362.09,
    y: 451.065
  }, "115"))), /*#__PURE__*/React.createElement("text", {
    id: "text222",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan280 || (_tspan280 = /*#__PURE__*/React.createElement("tspan", {
    x: 1362.09,
    y: 495.335
  }, "20.5"))), /*#__PURE__*/React.createElement("text", {
    id: "text223",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan281 || (_tspan281 = /*#__PURE__*/React.createElement("tspan", {
    x: 1362.09,
    y: 539.605
  }, "0.74"))), /*#__PURE__*/React.createElement("text", {
    id: "text224",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan282 || (_tspan282 = /*#__PURE__*/React.createElement("tspan", {
    x: 1362.09,
    y: 581.875
  }, "6.36"))), /*#__PURE__*/React.createElement("text", {
    id: "text225",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan283 || (_tspan283 = /*#__PURE__*/React.createElement("tspan", {
    x: 1362.09,
    y: 623.155
  }, "75.9"))), /*#__PURE__*/React.createElement("text", {
    id: "text226",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan284 || (_tspan284 = /*#__PURE__*/React.createElement("tspan", {
    x: 1410.4,
    y: 273.965
  }, "1.4"))), /*#__PURE__*/React.createElement("text", {
    id: "text227",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan285 || (_tspan285 = /*#__PURE__*/React.createElement("tspan", {
    x: 1406.36,
    y: 318.245
  }, "1.27"))), /*#__PURE__*/React.createElement("text", {
    id: "text228",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan286 || (_tspan286 = /*#__PURE__*/React.createElement("tspan", {
    x: 1406.58,
    y: 362.515
  }, "0.88"))), /*#__PURE__*/React.createElement("text", {
    id: "text229",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan287 || (_tspan287 = /*#__PURE__*/React.createElement("tspan", {
    x: 1410.4,
    y: 406.785
  }, "75"))), /*#__PURE__*/React.createElement("text", {
    id: "text230",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan288 || (_tspan288 = /*#__PURE__*/React.createElement("tspan", {
    x: 1406.36,
    y: 451.065
  }, "115"))), /*#__PURE__*/React.createElement("text", {
    id: "text231",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan289 || (_tspan289 = /*#__PURE__*/React.createElement("tspan", {
    x: 1406.36,
    y: 495.335
  }, "20.4"))), /*#__PURE__*/React.createElement("text", {
    id: "text232",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan290 || (_tspan290 = /*#__PURE__*/React.createElement("tspan", {
    x: 1410.62,
    y: 539.605
  }, "0.74"))), /*#__PURE__*/React.createElement("text", {
    id: "text233",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan291 || (_tspan291 = /*#__PURE__*/React.createElement("tspan", {
    x: 1406.36,
    y: 581.875
  }, "6.34"))), /*#__PURE__*/React.createElement("text", {
    id: "text234",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan292 || (_tspan292 = /*#__PURE__*/React.createElement("tspan", {
    x: 1406.36,
    y: 623.155
  }, "77.3"))), /*#__PURE__*/React.createElement("text", {
    id: "text235",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan293 || (_tspan293 = /*#__PURE__*/React.createElement("tspan", {
    x: 1450.63,
    y: 273.965
  }, "1.36"))), /*#__PURE__*/React.createElement("text", {
    id: "text236",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan294 || (_tspan294 = /*#__PURE__*/React.createElement("tspan", {
    x: 1450.63,
    y: 318.245
  }, "1.27"))), /*#__PURE__*/React.createElement("text", {
    id: "text237",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan295 || (_tspan295 = /*#__PURE__*/React.createElement("tspan", {
    x: 1450.63,
    y: 362.515
  }, "0.91"))), /*#__PURE__*/React.createElement("text", {
    id: "text238",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan296 || (_tspan296 = /*#__PURE__*/React.createElement("tspan", {
    x: 1450.85,
    y: 406.785
  }, "76.2"))), /*#__PURE__*/React.createElement("text", {
    id: "text239",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan297 || (_tspan297 = /*#__PURE__*/React.createElement("tspan", {
    x: 1450.63,
    y: 451.065
  }, "119"))), /*#__PURE__*/React.createElement("text", {
    id: "text240",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan298 || (_tspan298 = /*#__PURE__*/React.createElement("tspan", {
    x: 1450.63,
    y: 495.335
  }, "20.5"))), /*#__PURE__*/React.createElement("text", {
    id: "text241",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan299 || (_tspan299 = /*#__PURE__*/React.createElement("tspan", {
    x: 1450.63,
    y: 539.605
  }, "0.76"))), /*#__PURE__*/React.createElement("text", {
    id: "text242",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan300 || (_tspan300 = /*#__PURE__*/React.createElement("tspan", {
    x: 1450.63,
    y: 581.875
  }, "6.34"))), /*#__PURE__*/React.createElement("text", {
    id: "text243",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan301 || (_tspan301 = /*#__PURE__*/React.createElement("tspan", {
    x: 1450.85,
    y: 623.155
  }, "104"))), /*#__PURE__*/React.createElement("text", {
    id: "text244",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan302 || (_tspan302 = /*#__PURE__*/React.createElement("tspan", {
    x: 1495.12,
    y: 273.965
  }, "1.35"))), /*#__PURE__*/React.createElement("text", {
    id: "text245",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan303 || (_tspan303 = /*#__PURE__*/React.createElement("tspan", {
    x: 1494.9,
    y: 318.245
  }, "1.26"))), /*#__PURE__*/React.createElement("text", {
    id: "text246",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan304 || (_tspan304 = /*#__PURE__*/React.createElement("tspan", {
    x: 1494.9,
    y: 362.515
  }, "0.93"))), /*#__PURE__*/React.createElement("text", {
    id: "text247",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan305 || (_tspan305 = /*#__PURE__*/React.createElement("tspan", {
    x: 1496.61,
    y: 406.785
  }, "76.2"))), /*#__PURE__*/React.createElement("text", {
    id: "text248",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan306 || (_tspan306 = /*#__PURE__*/React.createElement("tspan", {
    x: 1494.9,
    y: 451.065
  }, "126"))), /*#__PURE__*/React.createElement("text", {
    id: "text249",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan307 || (_tspan307 = /*#__PURE__*/React.createElement("tspan", {
    x: 1495.12,
    y: 495.335
  }, "20"))), /*#__PURE__*/React.createElement("text", {
    id: "text250",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan308 || (_tspan308 = /*#__PURE__*/React.createElement("tspan", {
    x: 1494.9,
    y: 539.605
  }, "0.77"))), /*#__PURE__*/React.createElement("text", {
    id: "text251",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan309 || (_tspan309 = /*#__PURE__*/React.createElement("tspan", {
    x: 1494.9,
    y: 581.875
  }, "6.43"))), /*#__PURE__*/React.createElement("text", {
    id: "text252",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan310 || (_tspan310 = /*#__PURE__*/React.createElement("tspan", {
    x: 1495.12,
    y: 623.155
  }, "77.8"))), /*#__PURE__*/React.createElement("text", {
    id: "text253",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan311 || (_tspan311 = /*#__PURE__*/React.createElement("tspan", {
    x: 1539.18,
    y: 273.965
  }, "1.42"))), /*#__PURE__*/React.createElement("text", {
    id: "text254",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan312 || (_tspan312 = /*#__PURE__*/React.createElement("tspan", {
    x: 1539.18,
    y: 318.245
  }, "1.29"))), /*#__PURE__*/React.createElement("text", {
    id: "text255",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan313 || (_tspan313 = /*#__PURE__*/React.createElement("tspan", {
    x: 1539.18,
    y: 362.515
  }, "0.95"))), /*#__PURE__*/React.createElement("text", {
    id: "text256",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan314 || (_tspan314 = /*#__PURE__*/React.createElement("tspan", {
    x: 1541.89,
    y: 406.785
  }, "77.3"))), /*#__PURE__*/React.createElement("text", {
    id: "text257",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan315 || (_tspan315 = /*#__PURE__*/React.createElement("tspan", {
    x: 1543.22,
    y: 451.065
  }, "129"))), /*#__PURE__*/React.createElement("text", {
    id: "text258",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan316 || (_tspan316 = /*#__PURE__*/React.createElement("tspan", {
    x: 1539.18,
    y: 495.335
  }, "20"))), /*#__PURE__*/React.createElement("text", {
    id: "text259",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan317 || (_tspan317 = /*#__PURE__*/React.createElement("tspan", {
    x: 1539.4,
    y: 539.605
  }, "0.8"))), /*#__PURE__*/React.createElement("text", {
    id: "text260",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan318 || (_tspan318 = /*#__PURE__*/React.createElement("tspan", {
    x: 1539.4,
    y: 581.875
  }, "6.72"))), /*#__PURE__*/React.createElement("text", {
    id: "text261",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan319 || (_tspan319 = /*#__PURE__*/React.createElement("tspan", {
    x: 1539.4,
    y: 623.155
  }, "64.6"))), /*#__PURE__*/React.createElement("text", {
    id: "text262",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan320 || (_tspan320 = /*#__PURE__*/React.createElement("tspan", {
    x: 1583.45,
    y: 273.965
  }, "1.42"))), /*#__PURE__*/React.createElement("text", {
    id: "text263",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan321 || (_tspan321 = /*#__PURE__*/React.createElement("tspan", {
    x: 1583.45,
    y: 318.245
  }, "1.28"))), /*#__PURE__*/React.createElement("text", {
    id: "text264",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan322 || (_tspan322 = /*#__PURE__*/React.createElement("tspan", {
    x: 1583.45,
    y: 362.515
  }, "0.95"))), /*#__PURE__*/React.createElement("text", {
    id: "text265",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan323 || (_tspan323 = /*#__PURE__*/React.createElement("tspan", {
    x: 1584.16,
    y: 406.785
  }, "78.1"))), /*#__PURE__*/React.createElement("text", {
    id: "text266",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan324 || (_tspan324 = /*#__PURE__*/React.createElement("tspan", {
    x: 1583.67,
    y: 451.065
  }, "134"))), /*#__PURE__*/React.createElement("text", {
    id: "text267",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan325 || (_tspan325 = /*#__PURE__*/React.createElement("tspan", {
    x: 1583.45,
    y: 495.335
  }, "20"))), /*#__PURE__*/React.createElement("text", {
    id: "text268",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan326 || (_tspan326 = /*#__PURE__*/React.createElement("tspan", {
    x: 1583.67,
    y: 539.605
  }, "0.81"))), /*#__PURE__*/React.createElement("text", {
    id: "text269",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan327 || (_tspan327 = /*#__PURE__*/React.createElement("tspan", {
    x: 1583.45,
    y: 581.875
  }, "6.7"))), /*#__PURE__*/React.createElement("text", {
    id: "text270",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan328 || (_tspan328 = /*#__PURE__*/React.createElement("tspan", {
    x: 1583.67,
    y: 623.155
  }, "57.2"))), /*#__PURE__*/React.createElement("text", {
    id: "text271",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan329 || (_tspan329 = /*#__PURE__*/React.createElement("tspan", {
    x: 1627.72,
    y: 273.965
  }, "1.46"))), /*#__PURE__*/React.createElement("text", {
    id: "text272",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan330 || (_tspan330 = /*#__PURE__*/React.createElement("tspan", {
    x: 1627.72,
    y: 318.245
  }, "1.29"))), /*#__PURE__*/React.createElement("text", {
    id: "text273",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan331 || (_tspan331 = /*#__PURE__*/React.createElement("tspan", {
    x: 1627.72,
    y: 362.515
  }, "0.98"))), /*#__PURE__*/React.createElement("text", {
    id: "text274",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan332 || (_tspan332 = /*#__PURE__*/React.createElement("tspan", {
    x: 1627.94,
    y: 406.785
  }, "79.6"))), /*#__PURE__*/React.createElement("text", {
    id: "text275",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan333 || (_tspan333 = /*#__PURE__*/React.createElement("tspan", {
    x: 1627.94,
    y: 451.065
  }, "137"))), /*#__PURE__*/React.createElement("text", {
    id: "text276",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan334 || (_tspan334 = /*#__PURE__*/React.createElement("tspan", {
    x: 1627.72,
    y: 495.335
  }, "20.5"))), /*#__PURE__*/React.createElement("text", {
    id: "text277",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan335 || (_tspan335 = /*#__PURE__*/React.createElement("tspan", {
    x: 1627.72,
    y: 539.605
  }, "0.83"))), /*#__PURE__*/React.createElement("text", {
    id: "text278",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan336 || (_tspan336 = /*#__PURE__*/React.createElement("tspan", {
    x: 1627.72,
    y: 581.875
  }, "6.74"))), /*#__PURE__*/React.createElement("text", {
    id: "text279",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan337 || (_tspan337 = /*#__PURE__*/React.createElement("tspan", {
    x: 1627.72,
    y: 623.155
  }, "58.1"))), /*#__PURE__*/React.createElement("text", {
    id: "text280",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan338 || (_tspan338 = /*#__PURE__*/React.createElement("tspan", {
    x: 1672,
    y: 273.965
  }, "1.44"))), /*#__PURE__*/React.createElement("text", {
    id: "text281",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan339 || (_tspan339 = /*#__PURE__*/React.createElement("tspan", {
    x: 1672,
    y: 318.245
  }, "1.29"))), /*#__PURE__*/React.createElement("text", {
    id: "text282",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan340 || (_tspan340 = /*#__PURE__*/React.createElement("tspan", {
    x: 1669.21,
    y: 362.515
  }, "0.99"))), /*#__PURE__*/React.createElement("text", {
    id: "text283",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan341 || (_tspan341 = /*#__PURE__*/React.createElement("tspan", {
    x: 1672.21,
    y: 406.785
  }, "79.6"))), /*#__PURE__*/React.createElement("text", {
    id: "text284",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan342 || (_tspan342 = /*#__PURE__*/React.createElement("tspan", {
    x: 1672.21,
    y: 451.065
  }, "135"))), /*#__PURE__*/React.createElement("text", {
    id: "text285",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan343 || (_tspan343 = /*#__PURE__*/React.createElement("tspan", {
    x: 1676.04,
    y: 495.335
  }, "20.1"))), /*#__PURE__*/React.createElement("text", {
    id: "text286",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan344 || (_tspan344 = /*#__PURE__*/React.createElement("tspan", {
    x: 1672,
    y: 539.605
  }, "0.83"))), /*#__PURE__*/React.createElement("text", {
    id: "text287",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan345 || (_tspan345 = /*#__PURE__*/React.createElement("tspan", {
    x: 1676.04,
    y: 581.875
  }, "6.8"))), /*#__PURE__*/React.createElement("text", {
    id: "text288",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan346 || (_tspan346 = /*#__PURE__*/React.createElement("tspan", {
    x: 1672,
    y: 623.155
  }, "60.3"))), /*#__PURE__*/React.createElement("text", {
    id: "text289",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan347 || (_tspan347 = /*#__PURE__*/React.createElement("tspan", {
    x: 1720.53,
    y: 273.965
  }, "1.5"))), /*#__PURE__*/React.createElement("text", {
    id: "text290",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan348 || (_tspan348 = /*#__PURE__*/React.createElement("tspan", {
    x: 1716.49,
    y: 318.245
  }, "1.33"))), /*#__PURE__*/React.createElement("text", {
    id: "text291",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan349 || (_tspan349 = /*#__PURE__*/React.createElement("tspan", {
    x: 1716.49,
    y: 362.515
  }, "1.01"))), /*#__PURE__*/React.createElement("text", {
    id: "text292",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan350 || (_tspan350 = /*#__PURE__*/React.createElement("tspan", {
    x: 1718.98,
    y: 406.785
  }, "80.2"))), /*#__PURE__*/React.createElement("text", {
    id: "text293",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan351 || (_tspan351 = /*#__PURE__*/React.createElement("tspan", {
    x: 1716.27,
    y: 451.065
  }, "143"))), /*#__PURE__*/React.createElement("text", {
    id: "text294",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan352 || (_tspan352 = /*#__PURE__*/React.createElement("tspan", {
    x: 1720.31,
    y: 495.335
  }, "20"))), /*#__PURE__*/React.createElement("text", {
    id: "text295",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan353 || (_tspan353 = /*#__PURE__*/React.createElement("tspan", {
    x: 1716.27,
    y: 539.605
  }, "0.88"))), /*#__PURE__*/React.createElement("text", {
    id: "text296",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan354 || (_tspan354 = /*#__PURE__*/React.createElement("tspan", {
    x: 1716.31,
    y: 581.875
  }, "7.03"))), /*#__PURE__*/React.createElement("text", {
    id: "text297",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan355 || (_tspan355 = /*#__PURE__*/React.createElement("tspan", {
    x: 1716.53,
    y: 623.155
  }, "59.8"))), /*#__PURE__*/React.createElement("text", {
    id: "text298",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan356 || (_tspan356 = /*#__PURE__*/React.createElement("tspan", {
    x: 1760.54,
    y: 273.965
  }, "1.57"))), /*#__PURE__*/React.createElement("text", {
    id: "text299",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan357 || (_tspan357 = /*#__PURE__*/React.createElement("tspan", {
    x: 1760.54,
    y: 318.245
  }, "1.37"))), /*#__PURE__*/React.createElement("text", {
    id: "text300",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan358 || (_tspan358 = /*#__PURE__*/React.createElement("tspan", {
    x: 1760.54,
    y: 362.515
  }, "1.02"))), /*#__PURE__*/React.createElement("text", {
    id: "text301",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan359 || (_tspan359 = /*#__PURE__*/React.createElement("tspan", {
    x: 1763.25,
    y: 406.785
  }, "82.3"))), /*#__PURE__*/React.createElement("text", {
    id: "text302",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan360 || (_tspan360 = /*#__PURE__*/React.createElement("tspan", {
    x: 1760.54,
    y: 451.065
  }, "147"))), /*#__PURE__*/React.createElement("text", {
    id: "text303",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan361 || (_tspan361 = /*#__PURE__*/React.createElement("tspan", {
    x: 1760.76,
    y: 495.335
  }, "20"))), /*#__PURE__*/React.createElement("text", {
    id: "text304",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan362 || (_tspan362 = /*#__PURE__*/React.createElement("tspan", {
    x: 1760.76,
    y: 539.605
  }, "0.88"))), /*#__PURE__*/React.createElement("text", {
    id: "text305",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan363 || (_tspan363 = /*#__PURE__*/React.createElement("tspan", {
    x: 1760.76,
    y: 581.875
  }, "7.23"))), /*#__PURE__*/React.createElement("text", {
    id: "text306",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan364 || (_tspan364 = /*#__PURE__*/React.createElement("tspan", {
    x: 1760.54,
    y: 623.155
  }, "60.9"))), /*#__PURE__*/React.createElement("text", {
    id: "text307",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan365 || (_tspan365 = /*#__PURE__*/React.createElement("tspan", {
    x: 1804.81,
    y: 273.965
  }, "1.52"))), /*#__PURE__*/React.createElement("text", {
    id: "text308",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan366 || (_tspan366 = /*#__PURE__*/React.createElement("tspan", {
    x: 1804.81,
    y: 318.245
  }, "1.34"))), /*#__PURE__*/React.createElement("text", {
    id: "text309",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan367 || (_tspan367 = /*#__PURE__*/React.createElement("tspan", {
    x: 1804.81,
    y: 362.515
  }, "0.98"))), /*#__PURE__*/React.createElement("text", {
    id: "text310",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan368 || (_tspan368 = /*#__PURE__*/React.createElement("tspan", {
    x: 1804.81,
    y: 406.785
  }, "81.8"))), /*#__PURE__*/React.createElement("text", {
    id: "text311",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan369 || (_tspan369 = /*#__PURE__*/React.createElement("tspan", {
    x: 1805.03,
    y: 451.065
  }, "142"))), /*#__PURE__*/React.createElement("text", {
    id: "text312",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan370 || (_tspan370 = /*#__PURE__*/React.createElement("tspan", {
    x: 1804.81,
    y: 495.335
  }, "19.4"))), /*#__PURE__*/React.createElement("text", {
    id: "text313",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan371 || (_tspan371 = /*#__PURE__*/React.createElement("tspan", {
    x: 1804.81,
    y: 539.605
  }, "0.85"))), /*#__PURE__*/React.createElement("text", {
    id: "text314",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan372 || (_tspan372 = /*#__PURE__*/React.createElement("tspan", {
    x: 1805.03,
    y: 581.875
  }, "7.18"))), /*#__PURE__*/React.createElement("text", {
    id: "text315",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan373 || (_tspan373 = /*#__PURE__*/React.createElement("tspan", {
    x: 1803,
    y: 622.455
  }, "61.02"))), /*#__PURE__*/React.createElement("text", {
    id: "text316",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan374 || (_tspan374 = /*#__PURE__*/React.createElement("tspan", {
    x: 1849.09,
    y: 273.965
  }, "1.48"))), /*#__PURE__*/React.createElement("text", {
    id: "text317",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan375 || (_tspan375 = /*#__PURE__*/React.createElement("tspan", {
    x: 1849.09,
    y: 318.245
  }, "1.36"))), /*#__PURE__*/React.createElement("text", {
    id: "text318",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan376 || (_tspan376 = /*#__PURE__*/React.createElement("tspan", {
    x: 1849.3,
    y: 362.515
  }, "0.94"))), /*#__PURE__*/React.createElement("text", {
    id: "text319",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan377 || (_tspan377 = /*#__PURE__*/React.createElement("tspan", {
    x: 1849.3,
    y: 406.785
  }, "82.5"))), /*#__PURE__*/React.createElement("text", {
    id: "text320",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan378 || (_tspan378 = /*#__PURE__*/React.createElement("tspan", {
    x: 1849.09,
    y: 451.065
  }, "135"))), /*#__PURE__*/React.createElement("text", {
    id: "text321",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan379 || (_tspan379 = /*#__PURE__*/React.createElement("tspan", {
    x: 1849.09,
    y: 495.335
  }, "19.5"))), /*#__PURE__*/React.createElement("text", {
    id: "text322",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan380 || (_tspan380 = /*#__PURE__*/React.createElement("tspan", {
    x: 1849.3,
    y: 539.605
  }, "0.82"))), /*#__PURE__*/React.createElement("text", {
    id: "text323",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan381 || (_tspan381 = /*#__PURE__*/React.createElement("tspan", {
    x: 1849.3,
    y: 581.875
  }, "6.98"))), /*#__PURE__*/React.createElement("text", {
    id: "text324",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan382 || (_tspan382 = /*#__PURE__*/React.createElement("tspan", {
    x: 1849.09,
    y: 623.155
  }, "65.3")))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "line_group"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line 5",
    x1: 208.5,
    y1: 254,
    x2: 208.5,
    y2: 278,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 6",
    x1: 208.5,
    y1: 298,
    x2: 208.5,
    y2: 322,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 7",
    x1: 208.5,
    y1: 341,
    x2: 208.5,
    y2: 365,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 8",
    x1: 208.5,
    y1: 388,
    x2: 208.5,
    y2: 412,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 9",
    x1: 208.5,
    y1: 429,
    x2: 208.5,
    y2: 453,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 10",
    x1: 208.5,
    y1: 476,
    x2: 208.5,
    y2: 500,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 11",
    x1: 208.5,
    y1: 521,
    x2: 208.5,
    y2: 545,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 12",
    x1: 208.5,
    y1: 565,
    x2: 208.5,
    y2: 589,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 13",
    x1: 208.5,
    y1: 607,
    x2: 208.5,
    y2: 631,
    stroke: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "country_text",
    opacity: 0.98
  }, /*#__PURE__*/React.createElement("text", {
    id: "Australia",
    fill: "#262626",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan383 || (_tspan383 = /*#__PURE__*/React.createElement("tspan", {
    x: 137,
    y: 270.455
  }, "Australia"))), /*#__PURE__*/React.createElement("text", {
    id: "Canada",
    fill: "#262626",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan384 || (_tspan384 = /*#__PURE__*/React.createElement("tspan", {
    x: 137,
    y: 314.734
  }, "Canada"))), /*#__PURE__*/React.createElement("text", {
    id: "Europe",
    fill: "#262626",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan385 || (_tspan385 = /*#__PURE__*/React.createElement("tspan", {
    x: 137,
    y: 357.484
  }, "Europe"))), /*#__PURE__*/React.createElement("text", {
    id: "India",
    fill: "#262626",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan386 || (_tspan386 = /*#__PURE__*/React.createElement("tspan", {
    x: 137,
    y: 403.274
  }, "India"))), /*#__PURE__*/React.createElement("text", {
    id: "Japan",
    fill: "#262626",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan387 || (_tspan387 = /*#__PURE__*/React.createElement("tspan", {
    x: 137.34,
    y: 443.945
  }, "Japan"))), /*#__PURE__*/React.createElement("text", {
    id: "Mexico",
    fill: "#262626",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan388 || (_tspan388 = /*#__PURE__*/React.createElement("tspan", {
    x: 137,
    y: 491.825
  }, "Mexico"))), /*#__PURE__*/React.createElement("text", {
    id: "UK",
    fill: "#262626",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan389 || (_tspan389 = /*#__PURE__*/React.createElement("tspan", {
    x: 137,
    y: 536.095
  }, "UK"))), /*#__PURE__*/React.createElement("text", {
    id: "China",
    fill: "#262626",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan390 || (_tspan390 = /*#__PURE__*/React.createElement("tspan", {
    x: 137,
    y: 580.365
  }, "China"))), /*#__PURE__*/React.createElement("text", {
    id: "Russia",
    fill: "#262626",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 15,
    letterSpacing: "0em"
  }, _tspan391 || (_tspan391 = /*#__PURE__*/React.createElement("tspan", {
    x: 137,
    y: 624.644
  }, "Russia")))), /*#__PURE__*/React.createElement("g", {
    id: "legend"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1184,
    height: 66,
    transform: "translate(434 692)",
    fill: "#EAEAEA"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Frame 2",
    clipPath: "url(#clip0_0_1)"
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 577,
    height: 46,
    transform: "translate(444 702)",
    fill: "#EAEAEA"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 8",
    x: 454,
    y: 697,
    width: 64,
    height: 56,
    fill: "#C94949"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Rate increasing",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 20,
    letterSpacing: "0em"
  }, _tspan392 || (_tspan392 = /*#__PURE__*/React.createElement("tspan", {
    x: 528,
    y: 731.273
  }, "Rate increasing")))), /*#__PURE__*/React.createElement("g", {
    id: "Frame 3",
    clipPath: "url(#clip1_0_1)"
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 577,
    height: 46,
    transform: "translate(1031 702)",
    fill: "#EAEAEA"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 8_2",
    x: 1041,
    y: 697,
    width: 64,
    height: 56,
    fill: "#5E6980"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Rate decreasing",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 20,
    letterSpacing: "0em"
  }, _tspan393 || (_tspan393 = /*#__PURE__*/React.createElement("tspan", {
    x: 1115,
    y: 731.273
  }, "Rate decreasing")))))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "g_description_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M1984.28 692H1461.31L1342 795.22H1864.97L1984.28 692Z",
    fill: "#EAEAEA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 577,
    height: 46,
    fill: "white",
    transform: "translate(444 702)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 577,
    height: 46,
    fill: "white",
    transform: "translate(1031 702)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg);
export default __webpack_public_path__ + "static/media/svg.af4855c048614422ec2cb1e7bf13b0a0.svg";
export { ForwardRef as ReactComponent };